import React from "react";
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = React, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
  function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for (b in a) m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
    return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
  }
  reactJsxRuntime_production_min.Fragment = l;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var React$1 = React;
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }
        return null;
      }
      var ReactSharedInternals = React$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame2.getStackAddendum();
          if (stack !== "") {
            format += "%s";
            args = args.concat([stack]);
          }
          var argsWithFormat = args.map(function(item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) {
          return displayName;
        }
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }
      function getContextName(type) {
        return type.displayName || "Context";
      }
      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }
        {
          if (typeof type.tag === "number") {
            error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }
        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }
        if (typeof type === "string") {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
          case REACT_SUSPENSE_TYPE:
            return "Suspense";
          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;
              if (outerName !== null) {
                return outerName;
              }
              return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return getComponentNameFromType(init(payload));
              } catch (x) {
                return null;
              }
            }
          }
        }
        return null;
      }
      var assign = Object.assign;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;
      function disabledLog() {
      }
      disabledLog.__reactDisabledLog = true;
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }
          disabledDepth++;
        }
      }
      function reenableLogs() {
        {
          disabledDepth--;
          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
          }
          if (disabledDepth < 0) {
            error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;
      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === void 0) {
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || "";
            }
          }
          return "\n" + prefix + name;
        }
      }
      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }
      function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) {
          return "";
        }
        {
          var frame = componentFrameCache.get(fn);
          if (frame !== void 0) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }
        try {
          if (construct) {
            var Fake = function() {
              throw Error();
            };
            Object.defineProperty(Fake.prototype, "props", {
              set: function() {
                throw Error();
              }
            });
            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }
              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }
              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }
            fn();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;
            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              c--;
            }
            for (; s >= 1 && c >= 0; s--, c--) {
              if (sampleLines[s] !== controlLines[c]) {
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--;
                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
                      if (fn.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn.displayName);
                      }
                      {
                        if (typeof fn === "function") {
                          componentFrameCache.set(fn, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }
                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        {
          if (typeof fn === "function") {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }
      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }
      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }
        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }
        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }
        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");
          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
              } catch (x) {
              }
            }
          }
        }
        return "";
      }
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }
      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          var has = Function.call.bind(hasOwnProperty);
          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0;
              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$1 = ex;
              }
              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }
              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }
      var isArrayImpl = Array.isArray;
      function isArray(a) {
        return isArrayImpl(a);
      }
      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
          return type;
        }
      }
      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e) {
            return true;
          }
        }
      }
      function testStringCoercion(value) {
        return "" + value;
      }
      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value);
          }
        }
      }
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      function hasValidRef(config) {
        {
          if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== void 0;
      }
      function hasValidKey(config) {
        {
          if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== void 0;
      }
      function warnIfStringRefCannotBeAutoConverted(config, self) {
        {
          if (typeof config.ref === "string" && ReactCurrentOwner.current && self) ;
        }
      }
      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }
      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type,
          key,
          ref,
          props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          element._store = {};
          Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          });
          Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
          });
          Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });
          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      function jsxDEV(type, config, maybeKey, source, self) {
        {
          var propName;
          var props = {};
          var key = null;
          var ref = null;
          if (maybeKey !== void 0) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = "" + maybeKey;
          }
          if (hasValidKey(config)) {
            {
              checkKeyStringCoercion(config.key);
            }
            key = "" + config.key;
          }
          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
          }
          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          }
          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for (propName in defaultProps) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps[propName];
              }
            }
          }
          if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }
            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }
          return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
        }
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }
      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      function isValidElement(object) {
        {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }
      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) {
              return "\n\nCheck the render method of `" + name + "`.";
            }
          }
          return "";
        }
      }
      function getSourceInfoErrorAddendum(source) {
        {
          return "";
        }
      }
      var ownerHasKeyUseWarning = {};
      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();
          if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info;
        }
      }
      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }
          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          var childOwner = "";
          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }
          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== "object") {
            return;
          }
          if (isArray(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i];
              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") {
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;
                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      function validatePropTypes(element) {
        {
          var type = element.type;
          if (type === null || type === void 0 || typeof type === "string") {
            return;
          }
          var propTypes;
          if (typeof type === "function") {
            propTypes = type.propTypes;
          } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes = type.propTypes;
          } else {
            return;
          }
          if (propTypes) {
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
          } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
          }
          if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
            error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
      }
      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key !== "children" && key !== "key") {
              setCurrentlyValidatingElement$1(fragment);
              error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }
          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
          }
        }
      }
      var didWarnAboutKeySpread = {};
      function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        {
          var validType = isValidElementType(type);
          if (!validType) {
            var info = "";
            if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
              info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendum();
            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type === null) {
              typeString = "null";
            } else if (isArray(type)) {
              typeString = "array";
            } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
              info = " Did you accidentally export a JSX literal instead of a component?";
            } else {
              typeString = typeof type;
            }
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
          }
          var element = jsxDEV(type, props, key, source, self);
          if (element == null) {
            return element;
          }
          if (validType) {
            var children = props.children;
            if (children !== void 0) {
              if (isStaticChildren) {
                if (isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }
                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }
          {
            if (hasOwnProperty.call(props, "key")) {
              var componentName = getComponentNameFromType(type);
              var keys = Object.keys(props).filter(function(k) {
                return k !== "key";
              });
              var beforeExample = keys.length > 0 ? "{key: someKey, " + keys.join(": ..., ") + ": ...}" : "{key: someKey}";
              if (!didWarnAboutKeySpread[componentName + beforeExample]) {
                var afterExample = keys.length > 0 ? "{" + keys.join(": ..., ") + ": ...}" : "{}";
                error('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);
                didWarnAboutKeySpread[componentName + beforeExample] = true;
              }
            }
          }
          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }
          return element;
        }
      }
      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }
      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }
      var jsx = jsxWithValidationDynamic;
      var jsxs = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx;
      reactJsxRuntime_development.jsxs = jsxs;
    })();
  }
  return reactJsxRuntime_development;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  if (hasRequiredJsxRuntime) return jsxRuntime.exports;
  hasRequiredJsxRuntime = 1;
  if (process.env.NODE_ENV === "production") {
    jsxRuntime.exports = requireReactJsxRuntime_production_min();
  } else {
    jsxRuntime.exports = requireReactJsxRuntime_development();
  }
  return jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime();
let idCounter = 0;
const generateUniqueId = () => `icon-${++idCounter}-${Date.now()}`;
const createIcon = (svgContent2, displayName) => {
  const IconComponent = React.forwardRef(({
    primaryColor = "currentColor",
    secondaryColor = "#6B7280",
    size = 24,
    className = "",
    "aria-label": ariaLabel,
    ...props
  }, ref) => {
    const uniqueId = React.useMemo(() => generateUniqueId(), []);
    const processedSvg = React.useMemo(() => {
      return svgContent2.replace(/{{primaryColor}}/g, primaryColor).replace(/{{secondaryColor}}/g, secondaryColor).replace(/id="([^"]+)"/g, `id="${uniqueId}-$1"`).replace(/url\(#([^)]+)\)/g, `url(#${uniqueId}-$1)`);
    }, [svgContent2, primaryColor, secondaryColor, uniqueId]);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "span",
      {
        ref,
        className: `icon-wrapper ${className}`.trim(),
        style: { display: "inline-block", width: size, height: size },
        "aria-label": ariaLabel || displayName,
        role: "img",
        ...props,
        dangerouslySetInnerHTML: { __html: processedSvg }
      }
    );
  });
  IconComponent.displayName = displayName;
  return IconComponent;
};
const svgContent$1N = `<svg viewBox="0 0 20 20" fill="none" > <rect width="20" height="20" rx="10" fill="{{primaryColor}}"/> <path d="M15 8.0002V9.25036C14.9878 10.1245 14.6386 10.9578 14.0291 11.5672C13.4196 12.1765 12.5999 12.5119 11.75 12.4997H10.5V15H9.5V11.5001L9.50909 10.9998C9.58397 10.1724 9.95901 9.40437 10.5596 8.84852C11.1601 8.29267 11.9422 7.9898 12.75 8.0002H15ZM7 6.00012C7.72687 5.99407 8.43749 6.22131 9.03289 6.6502C9.62829 7.07908 10.0788 7.68827 10.3218 8.39292C9.94165 8.7124 9.62901 9.10846 9.4031 9.55677C9.1772 10.0051 9.04281 10.4962 9.00818 10.9998H8.5C7.58424 11.0123 6.70114 10.6503 6.04482 9.99328C5.3885 9.33628 5.01269 8.43811 5 7.4962V6.00012H7Z" fill="{{secondaryColor}}"/> </svg>`;
const AgeFilledIcon = createIcon(svgContent$1N, "AgeFilledIcon");
AgeFilledIcon.category = "dual-filled";
AgeFilledIcon.categoryName = "Dual Filled";
AgeFilledIcon.hasSecondaryColor = true;
const svgContent$1M = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_1_1760" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1_1760)"> <rect x="1" y="5" width="16" height="12" rx="3" fill="{{primaryColor}}"/> <path d="M6 5V4C6 2.89543 6.89543 2 8 2H10C11.1046 2 12 2.89543 12 4V5" stroke="{{primaryColor}}" stroke-width="1.5"/> <path d="M4 12H14" stroke="{{secondaryColor}}" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const BriefcaseFilledIcon = createIcon(svgContent$1M, "BriefcaseFilledIcon");
BriefcaseFilledIcon.category = "dual-filled";
BriefcaseFilledIcon.categoryName = "Dual Filled";
BriefcaseFilledIcon.hasSecondaryColor = true;
const svgContent$1L = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_39_26458" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_39_26458)"> <path d="M1 16.5V5.11803C1 4.73926 1.214 4.393 1.55279 4.22361L9.55279 0.223607C10.2177 -0.108844 11 0.374652 11 1.11803V16.5C11 17.0523 10.5523 17.5 10 17.5H2C1.44772 17.5 1 17.0523 1 16.5Z" fill="{{primaryColor}}"/> <path d="M16 17.5H13C12.4477 17.5 12 17.0523 12 16.5V6.26619C12 5.4889 12.848 5.00878 13.5145 5.4087L16.5145 7.2087C16.8157 7.38942 17 7.71493 17 8.06619V16.5C17 17.0523 16.5523 17.5 16 17.5Z" fill="{{primaryColor}}"/> <path d="M4 7.5H8" stroke="{{secondaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <path d="M4 11.5H8" stroke="{{secondaryColor}}" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const BuildingFilledIcon = createIcon(svgContent$1L, "BuildingFilledIcon");
BuildingFilledIcon.category = "dual-filled";
BuildingFilledIcon.categoryName = "Dual Filled";
BuildingFilledIcon.hasSecondaryColor = true;
const svgContent$1K = `<svg viewBox="0 0 20 20" fill="none" > <mask id="mask0_1_22002" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20"> <rect width="20" height="20" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1_22002)"> <path d="M13.7598 13.7329C16.2507 13.7329 18.3541 15.3888 19.0305 17.6599C19.1983 18.2231 18.7299 18.7329 18.1421 18.7329H9.37739C8.78966 18.7329 8.32121 18.2231 8.48899 17.6599C9.16548 15.3888 11.2689 13.7329 13.7598 13.7329Z" fill="{{primaryColor}}"/> <circle cx="13.7598" cy="10.2329" r="3" fill="{{primaryColor}}"/> <path d="M9.3125 1.45677C9.97718 1.12464 10.7594 1.60834 10.7598 2.35131V7.58864C10.1378 8.29364 9.75985 9.21912 9.75977 10.2332C9.75977 11.2472 10.1379 12.1727 10.7598 12.8777V13.4676C9.08388 14.3413 7.83778 15.9234 7.41705 17.8172C7.30366 18.3276 6.87737 18.7332 6.35456 18.7332H1.75977C1.20748 18.7332 0.759766 18.2855 0.759766 17.7332V6.35133C0.759986 5.97278 0.97389 5.6261 1.3125 5.45679L9.3125 1.45677Z" fill="{{primaryColor}}"/> <path d="M3.75977 8.73291H7.75977" stroke="{{secondaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <path d="M3.75977 12.7329H7.75977" stroke="{{secondaryColor}}" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const BuildingStaffFilledIcon = createIcon(svgContent$1K, "BuildingStaffFilledIcon");
BuildingStaffFilledIcon.category = "dual-filled";
BuildingStaffFilledIcon.categoryName = "Dual Filled";
BuildingStaffFilledIcon.hasSecondaryColor = true;
const svgContent$1J = `<svg viewBox="0 0 22 22" fill="none" > <circle cx="11" cy="11" r="11" fill="{{primaryColor}}"/> <rect x="6" y="8" width="10" height="8" rx="1" fill="{{secondaryColor}}"/> <circle cx="11" cy="12" r="2.25" stroke="{{primaryColor}}" stroke-width="1.5"/> <path d="M8.72361 6.55279C8.893 6.214 9.23926 6 9.61803 6H12.382C12.7607 6 13.107 6.214 13.2764 6.55279L14 8H8L8.72361 6.55279Z" fill="{{secondaryColor}}"/> </svg>`;
const CameraFilledIcon = createIcon(svgContent$1J, "CameraFilledIcon");
CameraFilledIcon.category = "dual-filled";
CameraFilledIcon.categoryName = "Dual Filled";
CameraFilledIcon.hasSecondaryColor = true;
const svgContent$1I = `<svg viewBox="0 0 20 20" fill="none" > <path d="M19.2069 5.70234C18.6939 4.57785 17.9615 3.56663 17.0524 2.72776C16.1377 1.87037 15.0698 1.19203 13.9041 0.728039C11.4068 -0.24268 8.63521 -0.24268 6.13786 0.728039C4.96034 1.18832 3.88078 1.86684 2.9562 2.72776C2.05995 3.57043 1.33915 4.58126 0.835086 5.70234C0.297165 6.8478 0.0123656 8.09526 0 9.36016C0.0136915 11.662 0.910134 13.8713 2.50525 15.5343L2.9562 19.3754C2.97657 19.547 3.05914 19.7053 3.18834 19.8204C3.31754 19.9355 3.48446 19.9995 3.65766 20.0003C3.78056 20.0006 3.90141 19.969 4.0084 19.9087L6.91449 18.2423C9.21638 18.9419 11.6873 18.8479 13.9292 17.9756C15.1067 17.5153 16.1863 16.8368 17.1108 15.9759C17.9954 15.1383 18.7074 14.1364 19.2069 13.0263C19.7298 11.876 20.0003 10.6275 20.0003 9.36433C20.0003 8.10121 19.7298 6.85267 19.2069 5.70234Z" fill="{{primaryColor}}"/> <circle cx="5.00002" cy="10" r="1.25002" fill="{{secondaryColor}}"/> <circle cx="10" cy="10" r="1.25002" fill="{{secondaryColor}}"/> <circle cx="15" cy="10" r="1.25002" fill="{{secondaryColor}}"/> </svg>`;
const ChatFilledIcon = createIcon(svgContent$1I, "ChatFilledIcon");
ChatFilledIcon.category = "dual-filled";
ChatFilledIcon.categoryName = "Dual Filled";
ChatFilledIcon.hasSecondaryColor = true;
const svgContent$1H = `<svg viewBox="0 0 32 32" fill="none"> <circle cx="16" cy="16" r="16" fill="{{primaryColor}}"/> <path d="M12 21L15.9293 17.0707C15.9683 17.0317 16.0317 17.0317 16.0707 17.0707L20 21" stroke="{{secondaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <path d="M12 15L15.9293 11.0707C15.9683 11.0317 16.0317 11.0317 16.0707 11.0707L20 15" stroke="{{secondaryColor}}" stroke-width="1.5" stroke-linecap="round"/> </svg>`;
const ChatLessFilledIcon = createIcon(svgContent$1H, "ChatLessFilledIcon");
ChatLessFilledIcon.category = "dual-filled";
ChatLessFilledIcon.categoryName = "Dual Filled";
ChatLessFilledIcon.hasSecondaryColor = true;
const svgContent$1G = `<svg viewBox="0 0 16 16" fill="none" > <circle cx="8" cy="8" r="8" fill="{{primaryColor}}"/> <circle cx="8" cy="8" r="3" fill="{{secondaryColor}}"/> </svg>`;
const CirclePointFilledIcon = createIcon(svgContent$1G, "CirclePointFilledIcon");
CirclePointFilledIcon.category = "dual-filled";
CirclePointFilledIcon.categoryName = "Dual Filled";
CirclePointFilledIcon.hasSecondaryColor = true;
const svgContent$1F = `<svg viewBox="0 0 24 24" fill="none" > <mask id="mask0_41_121836" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_41_121836)"> <path d="M4 18V6C4 3.79086 5.79086 2 8 2H15L21 8V18C21 20.2091 19.2091 22 17 22H8C5.79086 22 4 20.2091 4 18Z" fill="{{primaryColor}}"/> <path d="M15 2L21 8H16C15.4477 8 15 7.55228 15 7V2Z" fill="#C5D6F5"/> <path d="M8 16H17" stroke="{{secondaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <path d="M8 11H13" stroke="{{secondaryColor}}" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const ResumeIcon = createIcon(svgContent$1F, "ResumeIcon");
ResumeIcon.category = "dual-filled";
ResumeIcon.categoryName = "Dual Filled";
ResumeIcon.hasSecondaryColor = true;
const svgContent$1E = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_1_4927" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1_4927)"> <path d="M1 4.99609V13.0019C1 15.2111 2.79086 17 5 17H13C15.2091 17 17 15.2091 17 13V5C17 2.79086 15.2091 1 13 1H5C2.79086 1 1 2.78696 1 4.99609Z" fill="{{primaryColor}}"/> <path d="M6 8C6.55228 8 7 7.55228 7 7C7 6.44772 6.55228 6 6 6C5.44772 6 5 6.42772 5 6.98C5 7.53228 5.44772 8 6 8Z" fill="{{secondaryColor}}"/> <path d="M12 8C12.5523 8 13 7.55228 13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.42772 11 6.98C11 7.53228 11.4477 8 12 8Z" fill="{{secondaryColor}}"/> <path d="M6.5 10.5C6.5 10.5 7 12 9 12C11 12 11.5 10.5 11.5 10.5" stroke="{{secondaryColor}}" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const SmilingFaceFilledIcon = createIcon(svgContent$1E, "SmilingFaceFilledIcon");
SmilingFaceFilledIcon.category = "dual-filled";
SmilingFaceFilledIcon.categoryName = "Dual Filled";
SmilingFaceFilledIcon.hasSecondaryColor = true;
const svgContent$1D = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_1_6397" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1_6397)"> <circle cx="9" cy="5" r="5" fill="{{primaryColor}}"/> <path d="M17.5 16V14.5C17.5 11.7386 15.2614 9.5 12.5 9.5H5.5C2.73858 9.5 0.5 11.7386 0.5 14.5V16C0.5 16.5523 0.947715 17 1.5 17H16.5C17.0523 17 17.5 16.5523 17.5 16Z" fill="{{primaryColor}}"/> <path d="M10.876 12.7119C10.9545 12.9999 10.9003 13.3079 10.7282 13.5517L9.40848 15.4213C9.20928 15.7035 8.79072 15.7035 8.59152 15.4213L7.27181 13.5517C7.09969 13.3079 7.04548 12.9999 7.12402 12.7119L8 9.5H10L10.876 12.7119Z" fill="{{secondaryColor}}"/> </g> </svg>`;
const StaffFilledIcon = createIcon(svgContent$1D, "StaffFilledIcon");
StaffFilledIcon.category = "dual-filled";
StaffFilledIcon.categoryName = "Dual Filled";
StaffFilledIcon.hasSecondaryColor = true;
const svgContent$1C = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_1_12566" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1_12566)"> <circle cx="9" cy="9" r="8.25" stroke="{{primaryColor}}" stroke-width="1.5"/> <path d="M5 8.5L7.76 11.5L13.5 6" stroke="{{primaryColor}}" stroke-width="1.5"/> </g> </svg>`;
const AgreeIcon = createIcon(svgContent$1C, "AgreeIcon");
AgreeIcon.category = "single-color";
AgreeIcon.categoryName = "Single Color";
AgreeIcon.hasSecondaryColor = false;
const svgContent$1B = `<svg viewBox="0 0 24 24" fill="none" > <mask id="mask0_9603_203087" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_9603_203087)"> <path d="M20 12H4" stroke="{{primaryColor}}" stroke-width="2" stroke-linecap="round"/> <path d="M10 6L4.14142 11.8586C4.06332 11.9367 4.06332 12.0633 4.14142 12.1414L10 18" stroke="{{primaryColor}}" stroke-width="2" stroke-linecap="round"/> </g> </svg>`;
const BackIcon = createIcon(svgContent$1B, "BackIcon");
BackIcon.category = "single-color";
BackIcon.categoryName = "Single Color";
BackIcon.hasSecondaryColor = false;
const svgContent$1A = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_1_4918" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1_4918)"> <rect x="1.75" y="5.75" width="14.5" height="10.5" rx="2.25" stroke="{{primaryColor}}" stroke-width="1.5"/> <path d="M6 5V4C6 2.89543 6.89543 2 8 2H10C11.1046 2 12 2.89543 12 4V5" stroke="{{primaryColor}}" stroke-width="1.5"/> <path d="M4 12H14" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const BriefcaseIcon = createIcon(svgContent$1A, "BriefcaseIcon");
BriefcaseIcon.category = "single-color";
BriefcaseIcon.categoryName = "Single Color";
BriefcaseIcon.hasSecondaryColor = false;
const svgContent$1z = `<svg viewBox="0 0 24 24" fill="none"> <mask id="mask0_9200_191032" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="{{primaryColor}}"/> </mask> <g mask="url(#mask0_9200_191032)"> <path d="M3 9V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V9C21 7.89543 20.1046 7 19 7H5C3.89543 7 3 7.89543 3 9Z" stroke="{{primaryColor}}" stroke-width="2" stroke-linecap="round"/> <path d="M3 9L7.41421 13.4142C7.78929 13.7893 8.29799 14 8.82843 14H15.1716C15.702 14 16.2107 13.7893 16.5858 13.4142L21 9" stroke="{{primaryColor}}" stroke-width="2"/> <path d="M16 6V5C16 3.89543 15.1046 3 14 3H10C8.89543 3 8 3.89543 8 5V6" stroke="{{primaryColor}}" stroke-width="2"/> </g> </svg>`;
const ChatBagIcon = createIcon(svgContent$1z, "ChatBagIcon");
ChatBagIcon.category = "single-color";
ChatBagIcon.categoryName = "Single Color";
ChatBagIcon.hasSecondaryColor = false;
const svgContent$1y = `<svg viewBox="0 0 24 24" fill="none"> <mask id="mask0_9200_189729" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_9200_189729)"> <path d="M12.0222 20.9988C9.61249 20.9988 7.34837 20.0623 5.64386 18.3635C3.93934 16.6647 3 14.4034 3 11.9994C3 9.59536 3.93934 7.3341 5.64386 5.63529C7.34837 3.93648 9.61249 3 12.0222 3C13.3127 3 14.5604 3.26553 15.7282 3.79373C16.1593 3.98788 16.3535 4.49609 16.1593 4.92722C15.9652 5.35834 15.457 5.55249 15.0258 5.35834C14.0808 4.93293 13.0701 4.71594 12.0222 4.71594C10.0722 4.71594 8.23632 5.47255 6.85729 6.84872C5.47826 8.2249 4.71879 10.0522 4.71879 11.9965C4.71879 13.9409 5.47826 15.771 6.85729 17.1443C8.23632 18.5205 10.0722 19.2771 12.0222 19.2771C13.8438 19.2771 15.5883 18.6062 16.9331 17.3842C18.2693 16.1736 19.1058 14.5947 19.2885 12.8102C19.3371 12.3391 19.7568 11.9965 20.2279 12.0422C20.699 12.0907 21.0416 12.5105 20.9959 12.9816C20.7704 15.1886 19.7368 17.1558 18.0865 18.6518C16.4248 20.1679 14.2692 20.9988 12.0222 20.9988Z" fill="{{primaryColor}}"/> <path d="M20.1296 6.1671C19.7956 5.83019 19.2531 5.83019 18.9162 6.16424L11.9354 13.1251L8.90893 10.1072C8.57202 9.77314 8.02955 9.77314 7.69549 10.11C7.36144 10.4469 7.36144 10.9894 7.69835 11.3235L11.3301 14.9466C11.4985 15.1151 11.7155 15.1979 11.9354 15.1979C12.1552 15.1979 12.3751 15.1151 12.5435 14.9466L20.1267 7.38053C20.4637 7.04363 20.4637 6.50115 20.1296 6.1671Z" fill="{{primaryColor}}"/> </g> </svg>`;
const ChatCorrectIcon = createIcon(svgContent$1y, "ChatCorrectIcon");
ChatCorrectIcon.category = "single-color";
ChatCorrectIcon.categoryName = "Single Color";
ChatCorrectIcon.hasSecondaryColor = false;
const svgContent$1x = `<svg viewBox="0 0 14 4" fill="none"> <circle cx="12" cy="2" r="1.5" transform="rotate(90 12 2)" fill="{{primaryColor}}"/> <circle cx="7" cy="2" r="1.5" transform="rotate(90 7 2)" fill="{{primaryColor}}"/> <circle cx="2" cy="2" r="1.5" transform="rotate(90 2 2)" fill="{{primaryColor}}"/> </svg>`;
const ChatDotIcon = createIcon(svgContent$1x, "ChatDotIcon");
ChatDotIcon.category = "single-color";
ChatDotIcon.categoryName = "Single Color";
ChatDotIcon.hasSecondaryColor = false;
const svgContent$1w = `<svg viewBox="0 0 18 18" fill="none"> <mask id="mask0_9200_186563" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_9200_186563)"> <circle cx="9" cy="9" r="6" stroke="{{primaryColor}}" stroke-width="1.5"/> <path d="M5 5L13 13" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const ChatForbiddenIcon = createIcon(svgContent$1w, "ChatForbiddenIcon");
ChatForbiddenIcon.category = "single-color";
ChatForbiddenIcon.categoryName = "Single Color";
ChatForbiddenIcon.hasSecondaryColor = false;
const svgContent$1v = `<svg viewBox="0 0 20 20" fill="none"> <rect x="0.75" y="0.75" width="18.5" height="18.5" rx="3.25" stroke="{{primaryColor}}" stroke-width="1.5"/> <path d="M2 18L6.24254 12.909C6.63872 12.4335 7.36726 12.4285 7.77001 12.8983L9.2628 14.6399C9.65424 15.0966 10.3574 15.1069 10.762 14.6618L14.2115 10.8674C14.6253 10.4122 15.348 10.435 15.7323 10.9154L19 15" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <circle cx="6.5" cy="6.5" r="1.75" stroke="{{primaryColor}}" stroke-width="1.5"/> </svg>`;
const ChatImageIcon = createIcon(svgContent$1v, "ChatImageIcon");
ChatImageIcon.category = "single-color";
ChatImageIcon.categoryName = "Single Color";
ChatImageIcon.hasSecondaryColor = false;
const svgContent$1u = `<svg viewBox="0 0 18 18" fill="none"> <mask id="mask0_9200_189761" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_9200_189761)"> <path d="M14.5 9.5H3.5C2.94772 9.5 2.5 9.05228 2.5 8.5V6.5C2.5 5.94772 2.94772 5.5 3.5 5.5H14.5C15.0523 5.5 15.5 5.94772 15.5 6.5V8.5C15.5 9.05228 15.0523 9.5 14.5 9.5Z" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <path d="M4 9.5V14.5C4 15.0523 4.44772 15.5 5 15.5H13C13.5523 15.5 14 15.0523 14 14.5V9.5" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <path d="M7 12.5V15.5" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <path d="M11 12.5V15.5" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <path d="M7 5.5V4.5C7 3.39543 7.89543 2.5 9 2.5V2.5C10.1046 2.5 11 3.39543 11 4.5V5.5" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const ChatMarkIcon = createIcon(svgContent$1u, "ChatMarkIcon");
ChatMarkIcon.category = "single-color";
ChatMarkIcon.categoryName = "Single Color";
ChatMarkIcon.hasSecondaryColor = false;
const svgContent$1t = `<svg viewBox="0 0 32 32" fill="none"> <circle cx="16" cy="16" r="15.5" stroke="{{primaryColor}}"/> <path d="M20 11L16.0707 14.9293C16.0317 14.9683 15.9683 14.9683 15.9293 14.9293L12 11" stroke="{{secondaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <path d="M20 17L16.0707 20.9293C16.0317 20.9683 15.9683 20.9683 15.9293 20.9293L12 17" stroke="{{secondaryColor}}" stroke-width="1.5" stroke-linecap="round"/> </svg>`;
const ChatMoreIcon = createIcon(svgContent$1t, "ChatMoreIcon");
ChatMoreIcon.category = "single-color";
ChatMoreIcon.categoryName = "Single Color";
ChatMoreIcon.hasSecondaryColor = false;
const svgContent$1s = `<svg viewBox="0 0 14 14" fill="none" > <mask id="mask0_2433_231668" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14"> <rect width="14" height="14" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_2433_231668)"> <path d="M11.3802 2.43938C12.8129 3.8721 12.8129 6.19534 11.3802 7.62806L9.84789 9.16035L9.80577 9.39168L9.28166 12.2926C9.17392 12.8882 8.44117 13.1175 8.01314 12.6897L1.13059 5.80712C0.702576 5.3791 0.93201 4.64635 1.52765 4.53861L4.42858 4.01449L4.65991 3.97237L6.19221 2.44007C7.62485 1.00743 9.94745 1.00689 11.3802 2.43938Z" stroke="{{primaryColor}}" stroke-width="1.5"/> <path d="M4.32056 9.5L1.62431 12.196" stroke="{{primaryColor}}" stroke-width="1.5"/> </g> </svg>`;
const ChatPinIcon = createIcon(svgContent$1s, "ChatPinIcon");
ChatPinIcon.category = "single-color";
ChatPinIcon.categoryName = "Single Color";
ChatPinIcon.hasSecondaryColor = false;
const svgContent$1r = `<svg viewBox="0 0 16 16" fill="none" > <mask id="mask0_9563_127208" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16"> <rect width="16" height="16" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_9563_127208)"> <circle cx="8" cy="8.09961" r="6.9" stroke="{{primaryColor}}" stroke-width="1.2"/> <path d="M8.00019 4L8 8.5L11.0002 11" stroke="{{primaryColor}}" stroke-width="1.2"/> </g> </svg>`;
const ClockIcon = createIcon(svgContent$1r, "ClockIcon");
ClockIcon.category = "single-color";
ClockIcon.categoryName = "Single Color";
ClockIcon.hasSecondaryColor = false;
const svgContent$1q = `<svg viewBox="0 0 14 14" fill="none" > <mask id="mask0_1_1303" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14"> <rect width="14" height="14" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1_1303)"> <path d="M2 2L12 12" stroke="{{primaryColor}}" stroke-width="2" stroke-linecap="round"/> <path d="M12 2L2 12" stroke="{{primaryColor}}" stroke-width="2" stroke-linecap="round"/> </g> </svg>`;
const CloseIcon = createIcon(svgContent$1q, "CloseIcon");
CloseIcon.category = "single-color";
CloseIcon.categoryName = "Single Color";
CloseIcon.hasSecondaryColor = false;
const svgContent$1p = `<svg viewBox="0 0 14 14" fill="none" > <mask id="mask0_1005_28794" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14"> <rect width="14" height="14" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1005_28794)"> <path d="M9.7832 1.75C11.3095 1.75 12.6629 3.13091 12.6631 4.96777C12.6631 6.0318 12.1987 6.78782 11.7285 7.52246C11.1015 8.50011 9.96848 9.64409 8.92871 10.5859C8.41675 11.0497 7.9411 11.4521 7.58496 11.7451C7.40704 11.8915 7.25948 12.0107 7.15234 12.0957C7.09882 12.1382 7.05504 12.1717 7.02344 12.1963C7.00771 12.2085 6.99579 12.2193 6.98633 12.2266C6.98173 12.2301 6.97741 12.2322 6.97461 12.2344C6.97225 12.2362 6.97114 12.2379 6.9707 12.2383L6.96289 12.2432L6.95605 12.248L6.9502 12.2432L6.94238 12.2383L6.32617 11.7451C5.97149 11.4543 5.49512 11.0533 4.98145 10.5889C3.94082 9.648 2.80826 8.50488 2.18555 7.52539L2.18457 7.52344L2.00977 7.24609C1.60582 6.59451 1.25 5.89914 1.25 4.96777C1.25016 3.13091 2.60363 1.75 4.12988 1.75C4.98049 1.75015 5.79811 2.17741 6.3457 2.91602C6.64866 3.32437 7.25953 3.32543 7.56445 2.91895C8.12153 2.17545 8.93473 1.75008 9.7832 1.75Z" stroke="{{primaryColor}}" stroke-width="1.5"/> </g> </svg>`;
const CollectIcon = createIcon(svgContent$1p, "CollectIcon");
CollectIcon.category = "single-color";
CollectIcon.categoryName = "Single Color";
CollectIcon.hasSecondaryColor = false;
const svgContent$1o = `<svg viewBox="0 0 24 24" fill="none" > <mask id="mask0_9548_189089" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect x="0.5" y="0.5" width="23" height="23" fill="#D9D9D9" stroke="#666666"/> </mask> <g mask="url(#mask0_9548_189089)"> <path d="M2.5 8.33392V20C2.5 21.1046 3.39543 22 4.5 22H13.8C13.9105 22 14 21.9105 14 21.8V2.66675C14 1.91181 13.1955 1.42912 12.5294 1.78442L3.55875 6.56925C2.90706 6.91685 2.5 7.59532 2.5 8.33392Z" stroke="{{primaryColor}}" stroke-width="2" stroke-linecap="round"/> <path d="M21.5 12.2V20.0979C21.5 21.2165 20.5826 22.1176 19.4643 22.0976L14 22V7L20.4412 10.4353C21.0929 10.7829 21.5 11.4614 21.5 12.2Z" stroke="{{primaryColor}}" stroke-width="2"/> <path d="M5.5 17H11" stroke="{{primaryColor}}" stroke-width="2"/> <path d="M5.5 12H11" stroke="{{primaryColor}}" stroke-width="2"/> </g> </svg>`;
const CompanyIcon = createIcon(svgContent$1o, "CompanyIcon");
CompanyIcon.category = "single-color";
CompanyIcon.categoryName = "Single Color";
CompanyIcon.hasSecondaryColor = false;
const svgContent$1n = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_1_1787" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1_1787)"> <path d="M2.5 2.25H15.5C16.1904 2.25 16.75 2.80964 16.75 3.5V12.5C16.75 13.1904 16.1904 13.75 15.5 13.75H2.5C1.80964 13.75 1.25 13.1904 1.25 12.5V3.5C1.25 2.80964 1.80964 2.25 2.5 2.25Z" stroke="{{primaryColor}}" stroke-width="1.5"/> <path d="M5 10L7.84199 7.15801C7.92628 7.07372 8.06512 7.08141 8.13959 7.17449L9.86041 9.32551C9.93488 9.41859 10.0737 9.42628 10.158 9.34199L13 6.5" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <path d="M6 16.75H12" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const ComputerIcon = createIcon(svgContent$1n, "ComputerIcon");
ComputerIcon.category = "single-color";
ComputerIcon.categoryName = "Single Color";
ComputerIcon.hasSecondaryColor = false;
const svgContent$1m = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_9553_189288" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="{{primaryColor}}"/> </mask> <g mask="url(#mask0_9553_189288)"> <rect x="2.75" y="5.75" width="9.5" height="9.5" rx="2.25" stroke="{{primaryColor}}" stroke-width="1.5"/> <path d="M13 2C14.6569 2 16 3.34315 16 5V11C16 12.6569 14.6569 14 13 14H12.8262C12.9369 13.6869 13 13.351 13 13V12.5C13.8284 12.5 14.5 11.8284 14.5 11V5C14.5 4.17157 13.8284 3.5 13 3.5H7C6.17157 3.5 5.5 4.17157 5.5 5H5C4.649 5 4.31306 5.06306 4 5.17383V5C4 3.34315 5.34315 2 7 2H13Z" fill="{{primaryColor}}"/> </g> </svg>`;
const CopyIcon = createIcon(svgContent$1m, "CopyIcon");
CopyIcon.category = "single-color";
CopyIcon.categoryName = "Single Color";
CopyIcon.hasSecondaryColor = false;
const svgContent$1l = `<svg viewBox="0 0 16 16" fill="none" > <mask id="mask0_1_22780" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16"> <rect width="16" height="16" fill="#577CF6"/> </mask> <g mask="url(#mask0_1_22780)"> <path d="M1.25 8.5L5.25 12.5L14.75 3" stroke="{{primaryColor}}" stroke-width="2"/> </g> </svg>`;
const CorrectIcon = createIcon(svgContent$1l, "CorrectIcon");
CorrectIcon.category = "single-color";
CorrectIcon.categoryName = "Single Color";
CorrectIcon.hasSecondaryColor = false;
const svgContent$1k = `<svg viewBox="0 0 16 16" fill="none" > <mask id="mask0_9445_188915" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16"> <rect width="16" height="16" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_9445_188915)"> <rect x="3" y="4" width="10" height="9" stroke="{{primaryColor}}" stroke-width="1.2"/> <path d="M3 8H13" stroke="{{primaryColor}}" stroke-width="1.2"/> <path d="M6 2V4" stroke="{{primaryColor}}" stroke-width="1.2"/> <path d="M10 2V4" stroke="{{primaryColor}}" stroke-width="1.2"/> </g> </svg>`;
const DateIcon = createIcon(svgContent$1k, "DateIcon");
DateIcon.category = "single-color";
DateIcon.categoryName = "Single Color";
DateIcon.hasSecondaryColor = false;
const svgContent$1j = `<svg viewBox="0 0 18 18" fill="none" > <g> <path d="M4.5 5.5V13.5C4.5 14.6046 5.39543 15.5 6.5 15.5H11.5C12.6046 15.5 13.5 14.6046 13.5 13.5V5.5" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <path d="M2.5 5.5H15.5" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <path d="M6.5 2.5H11.5" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <path d="M7.5 8.5L7.5 12.5" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <path d="M10.5 8.5L10.5 12.5" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const DeleteIcon = createIcon(svgContent$1j, "DeleteIcon");
DeleteIcon.category = "single-color";
DeleteIcon.categoryName = "Single Color";
DeleteIcon.hasSecondaryColor = false;
const svgContent$1i = `<svg viewBox="0 0 16 16" fill="none" > <mask id="mask0_9445_188901" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16"> <rect width="16" height="16" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_9445_188901)"> <path d="M13 5.5L8 10.5L3 5.5" stroke="{{primaryColor}}" stroke-width="1.5"/> </g> </svg>`;
const DownIcon = createIcon(svgContent$1i, "DownIcon");
DownIcon.category = "single-color";
DownIcon.categoryName = "Single Color";
DownIcon.hasSecondaryColor = false;
const svgContent$1h = `<svg viewBox="0 0 14 14" fill="none" > <mask id="mask0_45_26485" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14"> <rect width="14" height="14" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_45_26485)"> <path d="M8 1H2C1.44772 1 1 1.44772 1 2V12C1 12.5523 1.44772 13 2 13H12C12.5523 13 13 12.5523 13 12V6" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <path d="M6 8L12.5 1.5" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const EditIcon = createIcon(svgContent$1h, "EditIcon");
EditIcon.category = "single-color";
EditIcon.categoryName = "Single Color";
EditIcon.hasSecondaryColor = false;
const svgContent$1g = `<svg viewBox="0 0 24 24" fill="none" > <mask id="mask0_10831_140734" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_10831_140734)"> <path d="M17.0694 8.76497L15.23 6.92726C14.9036 6.6009 14.9036 6.07034 15.23 5.74397L16.2292 4.74478C16.5556 4.41841 17.0861 4.41841 17.4125 4.74478L19.2502 6.58248C19.5766 6.90885 19.5766 7.43941 19.2502 7.76578L18.251 8.76497C17.9246 9.09301 17.3958 9.09301 17.0694 8.76497ZM15.9882 11.0178C16.3028 10.7031 16.3815 10.273 16.1639 10.0571L13.9279 7.81934C13.712 7.60343 13.2818 7.6821 12.9672 7.99508L4.77616 15.9685C4.61883 16.1258 4.52008 16.3267 4.5 16.5292L4.50335 18.7686C4.46318 19.1904 4.79457 19.5218 5.21634 19.4816L7.45573 19.5C7.65825 19.4799 7.86076 19.3812 8.01642 19.2238L15.9882 11.0178ZM18.6276 17.3493H12.7848C12.5605 17.3493 12.3462 17.438 12.1889 17.597C11.9027 17.8849 11.4307 18.3719 11.0374 18.7803C10.783 19.0448 10.9705 19.4849 11.337 19.4849H18.6226C19.0912 19.4849 19.4745 19.1017 19.4745 18.633V18.1929C19.4711 17.7292 19.0929 17.3493 18.6276 17.3493Z" fill="{{primaryColor}}"/> </g> </svg>`;
const EditPenIcon = createIcon(svgContent$1g, "EditPenIcon");
EditPenIcon.category = "single-color";
EditPenIcon.categoryName = "Single Color";
EditPenIcon.hasSecondaryColor = false;
const svgContent$1f = `<svg viewBox="0 0 24 24" fill="none" > <mask id="mask0_11807_149305" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_11807_149305)"> <circle cx="12" cy="12" r="8.25" stroke="{{primaryColor}}" stroke-width="1.5"/> <path d="M12 8V13" stroke="{{primaryColor}}" stroke-width="1.5"/> <path d="M12 14V16" stroke="{{primaryColor}}" stroke-width="1.5"/> </g> </svg>`;
const HintIcon = createIcon(svgContent$1f, "HintIcon");
HintIcon.category = "single-color";
HintIcon.categoryName = "Single Color";
HintIcon.hasSecondaryColor = false;
const svgContent$1e = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_1_1769" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1_1769)"> <path d="M7 1.75H11C13.8995 1.75 16.25 4.10051 16.25 7V11C16.25 13.8995 13.8995 16.25 11 16.25H3C2.30964 16.25 1.75 15.6904 1.75 15V7C1.75 4.10051 4.10051 1.75 7 1.75Z" stroke="{{primaryColor}}" stroke-width="1.5"/> <path d="M5 11H10" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <path d="M5 7.5H13" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const InformationIcon = createIcon(svgContent$1e, "InformationIcon");
InformationIcon.category = "single-color";
InformationIcon.categoryName = "Single Color";
InformationIcon.hasSecondaryColor = false;
const svgContent$1d = `<svg viewBox="0 0 24 24" fill="none" > <mask id="mask0_13369_15187" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_13369_15187)"> <path d="M15.7598 15.7324C18.2507 15.7324 20.3541 17.3884 21.0305 19.6594C21.1983 20.2227 20.7299 20.7324 20.1421 20.7324H11.3774C10.7897 20.7324 10.3212 20.2227 10.489 19.6594C11.1655 17.3884 13.2689 15.7324 15.7598 15.7324Z" fill="{{primaryColor}}"/> <circle cx="15.7598" cy="12.2324" r="3" fill="{{primaryColor}}"/> <path d="M11.3125 3.45629C11.9772 3.12415 12.7594 3.60785 12.7598 4.35082V9.58815C12.1378 10.2931 11.7598 11.2186 11.7598 12.2327C11.7598 13.2467 12.1379 14.1722 12.7598 14.8772V15.4671C11.0839 16.3408 9.83778 17.9229 9.41705 19.8167C9.30366 20.3271 8.87737 20.7327 8.35456 20.7327H3.75977C3.20748 20.7327 2.75977 20.285 2.75977 19.7327V8.35084C2.75999 7.9723 2.97389 7.62561 3.3125 7.45631L11.3125 3.45629Z" fill="{{primaryColor}}"/> <path d="M5.75977 10.7324H9.75977" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <path d="M5.75977 14.7324H9.75977" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const JoinCompanyIcon = createIcon(svgContent$1d, "JoinCompanyIcon");
JoinCompanyIcon.category = "single-color";
JoinCompanyIcon.categoryName = "Single Color";
JoinCompanyIcon.hasSecondaryColor = false;
const svgContent$1c = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_1_6322" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1_6322)"> <path d="M1 15V3C1 2.44772 1.44772 2 2 2H8V16H2C1.44772 16 1 15.5523 1 15Z" stroke="{{primaryColor}}" stroke-width="1.8"/> <path d="M9 2H13" stroke="{{primaryColor}}" stroke-width="1.8" stroke-linecap="round"/> <path d="M9 16H13" stroke="{{primaryColor}}" stroke-width="1.8" stroke-linecap="round"/> <path d="M14 6L16.9293 8.92929C16.9683 8.96834 16.9683 9.03166 16.9293 9.07071L14 12" stroke="{{primaryColor}}" stroke-width="1.8" stroke-linecap="round"/> <path d="M11 8.1C10.5029 8.1 10.1 8.50294 10.1 9C10.1 9.49706 10.5029 9.9 11 9.9V9V8.1ZM16 9V8.1H11V9V9.9H16V9Z" fill="{{primaryColor}}"/> </g> </svg>`;
const LeaveCompanyIcon = createIcon(svgContent$1c, "LeaveCompanyIcon");
LeaveCompanyIcon.category = "single-color";
LeaveCompanyIcon.categoryName = "Single Color";
LeaveCompanyIcon.hasSecondaryColor = false;
const svgContent$1b = `<svg viewBox="0 0 16 16" fill="none" > <mask id="mask0_9445_189408" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16"> <rect width="16" height="16" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_9445_189408)"> <path d="M8 0.599609C11.5187 0.599609 14.4003 3.53919 14.4004 7.2002C14.4003 8.04921 14.0751 8.99094 13.5225 9.9541C12.9731 10.9115 12.2223 11.8489 11.4307 12.6768C10.64 13.5036 9.82187 14.2073 9.14941 14.7002C8.81236 14.9472 8.52042 15.1351 8.29395 15.2578C8.18056 15.3192 8.09218 15.3594 8.0293 15.3828C8.018 15.387 8.00797 15.389 8 15.3916C7.99203 15.389 7.982 15.387 7.9707 15.3828C7.90782 15.3594 7.81944 15.3192 7.70605 15.2578C7.47958 15.1351 7.18764 14.9472 6.85059 14.7002C6.17813 14.2073 5.36001 13.5036 4.56934 12.6768C3.7777 11.8489 3.02689 10.9115 2.47754 9.9541C1.92493 8.99094 1.5997 8.04921 1.59961 7.2002C1.59969 3.53919 4.4813 0.599609 8 0.599609Z" stroke="{{primaryColor}}" stroke-width="1.2"/> <path d="M8 5.09961C9.04934 5.09961 9.90039 5.95066 9.90039 7C9.90039 8.04934 9.04934 8.90039 8 8.90039C6.95066 8.90039 6.09961 8.04934 6.09961 7C6.09961 5.95066 6.95066 5.09961 8 5.09961Z" stroke="{{primaryColor}}" stroke-width="1.2"/> </g> </svg>`;
const LocationIcon = createIcon(svgContent$1b, "LocationIcon");
LocationIcon.category = "single-color";
LocationIcon.categoryName = "Single Color";
LocationIcon.hasSecondaryColor = false;
const svgContent$1a = `<svg viewBox="0 0 24 24" fill="none" > <mask id="mask0_4538_92096" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_4538_92096)"> <path d="M15 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H15" stroke="{{primaryColor}}" stroke-width="2"/> <path d="M16 8L19.8586 11.8586C19.9367 11.9367 19.9367 12.0633 19.8586 12.1414L16 16" stroke="{{primaryColor}}" stroke-width="2" stroke-linecap="round"/> <path d="M9 12H19" stroke="{{primaryColor}}" stroke-width="2"/> </g> </svg>`;
const LogoutIcon = createIcon(svgContent$1a, "LogoutIcon");
LogoutIcon.category = "single-color";
LogoutIcon.categoryName = "Single Color";
LogoutIcon.hasSecondaryColor = false;
const svgContent$19 = `<svg viewBox="0 0 14 14" fill="none" > <mask id="mask0_11748_144758" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14"> <rect width="14" height="14" fill="#ECEEF0"/> </mask> <g mask="url(#mask0_11748_144758)"> <circle cx="7" cy="6.5" r="5.5" stroke="{{primaryColor}}"/> <path d="M4 6.5H10" stroke="{{primaryColor}}"/> <path d="M7.00488 3.50586L7.00488 9.50586" stroke="{{primaryColor}}"/> <path d="M10.5 10.5L13 13.5" stroke="{{primaryColor}}"/> </g> </svg>`;
const MagnifierIcon = createIcon(svgContent$19, "MagnifierIcon");
MagnifierIcon.category = "single-color";
MagnifierIcon.categoryName = "Single Color";
MagnifierIcon.hasSecondaryColor = false;
const svgContent$18 = `<svg viewBox="0 0 24 24" fill="none" > <mask id="mask0_869_157086" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_869_157086)"> <rect x="3" y="4" width="18" height="2" fill="{{primaryColor}}"/> <rect x="3" y="11" width="18" height="2" fill="{{primaryColor}}"/> <rect x="3" y="18" width="18" height="2" fill="{{primaryColor}}"/> </g> </svg>`;
const MenuIcon = createIcon(svgContent$18, "MenuIcon");
MenuIcon.category = "single-color";
MenuIcon.categoryName = "Single Color";
MenuIcon.hasSecondaryColor = false;
const svgContent$17 = `<svg viewBox="0 0 14 14" fill="none" > <mask id="mask0_45_26480" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14"> <rect width="14" height="14" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_45_26480)"> <circle cx="1.5" cy="7" r="1.5" fill="{{primaryColor}}"/> <circle cx="12.5" cy="7" r="1.5" fill="{{primaryColor}}"/> <circle cx="7" cy="7" r="2" fill="{{primaryColor}}"/> </g> </svg>`;
const MoreIcon = createIcon(svgContent$17, "MoreIcon");
MoreIcon.category = "single-color";
MoreIcon.categoryName = "Single Color";
MoreIcon.hasSecondaryColor = false;
const svgContent$16 = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_1_1796" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1_1796)"> <path d="M9.92676 9.25L11.1367 13.6855C11.1585 13.7654 11.1396 13.8512 11.0859 13.9141L9.18945 16.126C9.08969 16.2422 8.91031 16.2422 8.81055 16.126L6.91406 13.9141C6.86036 13.8512 6.84151 13.7654 6.86328 13.6855L8.07324 9.25H9.92676Z" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <circle cx="9" cy="5" r="4.25" stroke="{{primaryColor}}" stroke-width="1.5"/> <path d="M17 16V14.5C17 11.7386 14.7614 9.5 12 9.5H6C3.23858 9.5 1 11.7386 1 14.5V16" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const PeopleIcon = createIcon(svgContent$16, "PeopleIcon");
PeopleIcon.category = "single-color";
PeopleIcon.categoryName = "Single Color";
PeopleIcon.hasSecondaryColor = false;
const svgContent$15 = `<svg viewBox="0 0 14 14" fill="none" > <path d="M4 0.5H10C11.933 0.5 13.5 2.067 13.5 4V12C13.5 12.8284 12.8284 13.5 12 13.5H4C2.067 13.5 0.5 11.933 0.5 10V4C0.5 2.067 2.067 0.5 4 0.5Z" stroke="{{primaryColor}}" stroke-linecap="round"/> <path d="M3 5.5H11" stroke="{{primaryColor}}"/> <path d="M3 8.5H8" stroke="{{primaryColor}}"/> </svg>`;
const PhraseIcon = createIcon(svgContent$15, "PhraseIcon");
PhraseIcon.category = "single-color";
PhraseIcon.categoryName = "Single Color";
PhraseIcon.hasSecondaryColor = false;
const svgContent$14 = `<svg viewBox="0 0 24 24" fill="none" > <path d="M0 11.9941H24" stroke="{{primaryColor}}" stroke-width="3"/> <path d="M12.0059 0L12.0059 24" stroke="{{primaryColor}}" stroke-width="3"/> </svg>`;
const PlusBoldIcon = createIcon(svgContent$14, "PlusBoldIcon");
PlusBoldIcon.category = "single-color";
PlusBoldIcon.categoryName = "Single Color";
PlusBoldIcon.hasSecondaryColor = false;
const svgContent$13 = `<svg viewBox="0 0 24 24" fill="none" > <path d="M0 11.9941H24" stroke="{{primaryColor}}" stroke-width="2"/> <path d="M12.0059 0L12.0059 24" stroke="{{primaryColor}}" stroke-width="2"/> </svg>`;
const PlusIcon = createIcon(svgContent$13, "PlusIcon");
PlusIcon.category = "single-color";
PlusIcon.categoryName = "Single Color";
PlusIcon.hasSecondaryColor = false;
const svgContent$12 = `<svg viewBox="0 0 22 22" fill="none" > <mask id="mask0_45_26475" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="22" height="22"> <rect width="22" height="22" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_45_26475)"> <path d="M11 4.75C13.5234 4.75 15.9105 5.45396 17.6406 6.66504C19.3682 7.87436 20.25 9.4462 20.25 11C20.25 12.5538 19.3682 14.1256 17.6406 15.335C15.9105 16.546 13.5234 17.25 11 17.25C8.47658 17.25 6.08952 16.546 4.35938 15.335C2.63178 14.1256 1.75 12.5538 1.75 11C1.75 9.4462 2.63178 7.87436 4.35938 6.66504C6.08952 5.45396 8.47658 4.75 11 4.75Z" stroke="{{primaryColor}}" stroke-width="1.5"/> <path d="M11 8.25C12.5158 8.25 13.75 9.48425 13.75 11C13.75 12.5158 12.5158 13.75 11 13.75C9.48425 13.75 8.25 12.5158 8.25 11C8.25 9.48425 9.48425 8.25 11 8.25Z" stroke="{{primaryColor}}" stroke-width="1.5"/> </g> </svg>`;
const PreviewIcon = createIcon(svgContent$12, "PreviewIcon");
PreviewIcon.category = "single-color";
PreviewIcon.categoryName = "Single Color";
PreviewIcon.hasSecondaryColor = false;
const svgContent$11 = `<svg viewBox="0 0 24 24" fill="none" > <mask id="mask0_4538_92114" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_4538_92114)"> <path d="M19.5 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V8C2.5 6.89543 3.39543 6 4.5 6H19.5C20.6046 6 21.5 6.89543 21.5 8V19.5C21.5 20.6046 20.6046 21.5 19.5 21.5Z" stroke="{{primaryColor}}" stroke-width="2"/> <path d="M7 16.5H17" stroke="{{primaryColor}}" stroke-width="2"/> <path d="M7 12.5H13" stroke="{{primaryColor}}" stroke-width="2"/> <path d="M9 3.5C9 2.94772 8.55228 2.5 8 2.5C7.44771 2.5 7 2.94772 7 3.5L9 3.5ZM8 3.5L7 3.5L7 9L8 9L9 9L9 3.5L8 3.5Z" fill="{{primaryColor}}"/> <path d="M17 3.5C17 2.94772 16.5523 2.5 16 2.5C15.4477 2.5 15 2.94772 15 3.5L17 3.5ZM16 3.5L15 3.5L15 9L16 9L17 9L17 3.5L16 3.5Z" fill="{{primaryColor}}"/> </g> </svg>`;
const ProfileIcon = createIcon(svgContent$11, "ProfileIcon");
ProfileIcon.category = "single-color";
ProfileIcon.categoryName = "Single Color";
ProfileIcon.hasSecondaryColor = false;
const svgContent$10 = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_41_122786" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_41_122786)"> <path d="M3 9L6 12L12 6" stroke="{{primaryColor}}" stroke-width="1.2" stroke-linecap="square"/> <path d="M9 12L10 13L16 7" stroke="{{primaryColor}}" stroke-width="1.2" stroke-linecap="square"/> </g> </svg>`;
const ReadedIcon = createIcon(svgContent$10, "ReadedIcon");
ReadedIcon.category = "single-color";
ReadedIcon.categoryName = "Single Color";
ReadedIcon.hasSecondaryColor = false;
const svgContent$$ = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_1_12560" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1_12560)"> <circle cx="9" cy="9" r="8.25" stroke="{{primaryColor}}" stroke-width="1.5"/> <path d="M6.00098 6L12.0001 11.9883" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <path d="M11.999 6.01172L5.99988 12" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const RejectIcon = createIcon(svgContent$$, "RejectIcon");
RejectIcon.category = "single-color";
RejectIcon.categoryName = "Single Color";
RejectIcon.hasSecondaryColor = false;
const svgContent$_ = `<svg viewBox="0 0 18 18" fill="none" > <g mask="url(#mask0_10692_203422)"> <path d="M15 8L15 5C15 3.89543 14.1046 3 13 3L5 3C3.89543 3 3 3.89543 3 5L3 13C3 14.1046 3.89543 15 5 15L9 15" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <path d="M12 7L6 7" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <path d="M9 11L6 11" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> <path d="M11 13L12.8586 14.8586C12.9367 14.9367 13.0633 14.9367 13.1414 14.8586L17 11" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const RepublishIcon = createIcon(svgContent$_, "RepublishIcon");
RepublishIcon.category = "single-color";
RepublishIcon.categoryName = "Single Color";
RepublishIcon.hasSecondaryColor = false;
const svgContent$Z = `<svg viewBox="0 0 16 16" fill="none" > <path d="M1.58175 3.45738C3.76349 0.25052 7.99327 -0.947197 11.5579 0.811664C15.4825 2.74767 17.1122 7.53625 15.1979 11.5065C13.2836 15.4768 8.54985 17.1248 4.62522 15.1888C3.06224 14.4186 1.79688 13.1545 1.02517 11.5923C0.930794 11.4029 0.914818 11.1839 0.980702 10.9829C1.04659 10.7818 1.18903 10.6148 1.37718 10.518C1.47016 10.4709 1.57156 10.4428 1.67551 10.4353C1.77945 10.4277 1.88385 10.4409 1.98265 10.4741C2.08144 10.5073 2.17265 10.5598 2.25098 10.6285C2.3293 10.6973 2.39318 10.7809 2.4389 10.8745C3.05597 12.1244 4.06837 13.1355 5.31894 13.7511C8.45842 15.3008 12.2448 13.9808 13.7762 10.8048C15.3077 7.62882 14.0048 3.7991 10.8642 2.24938C7.85384 0.763664 4.25036 1.91452 2.60691 4.80939H3.95435C4.39207 4.80939 4.74522 5.16824 4.74522 5.60939C4.74522 6.05167 4.39093 6.40939 3.95435 6.40939H0.790881C0.686422 6.40879 0.583104 6.38762 0.486825 6.3471C0.390547 6.30657 0.303195 6.24747 0.229756 6.17319C0.156316 6.0989 0.0982287 6.01087 0.0588094 5.91414C0.0193901 5.8174 -0.000588852 5.71385 1.32129e-05 5.60939V2.40938C1.32129e-05 1.96824 0.354304 1.60938 0.790881 1.60938C1.22746 1.60938 1.58175 1.96824 1.58175 2.40938V3.45738Z" fill="{{primaryColor}}"/> </svg>`;
const ResetIcon = createIcon(svgContent$Z, "ResetIcon");
ResetIcon.category = "single-color";
ResetIcon.categoryName = "Single Color";
ResetIcon.hasSecondaryColor = false;
const svgContent$Y = `<svg viewBox="0 0 18 18" fill="none"> <mask id="mask0_1301_392990" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect x="0.5" y="0.5" width="17" height="17" fill="#D9D9D9" stroke="{{primaryColor}}"/> </mask> <g mask="url(#mask0_1301_392990)"> <path d="M3 14H11C13.2091 14 15 12.2091 15 10V10C15 7.79086 13.2091 6 11 6H5" stroke="{{primaryColor}}" stroke-width="1.5"/> <path d="M8 3L5 6L8 9" stroke="{{primaryColor}}" stroke-width="1.5"/> </g> </svg>`;
const RevokeIcon = createIcon(svgContent$Y, "RevokeIcon");
RevokeIcon.category = "single-color";
RevokeIcon.categoryName = "Single Color";
RevokeIcon.hasSecondaryColor = false;
const svgContent$X = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_11635_149893" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect x="18" y="18" width="18" height="18" transform="rotate(-180 18 18)" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_11635_149893)"> <path d="M6.5 14L11.5 9L6.5 4" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const RightIcon = createIcon(svgContent$X, "RightIcon");
RightIcon.category = "single-color";
RightIcon.categoryName = "Single Color";
RightIcon.hasSecondaryColor = false;
const svgContent$W = `<svg viewBox="0 0 19 18" fill="none" > <circle cx="8.08825" cy="7.58825" r="6.58825" stroke="{{primaryColor}}" stroke-width="2"/> <path d="M17.4987 17.0007L14.6752 14.1772L12.3223 11.8242" stroke="{{primaryColor}}" stroke-width="2"/> </svg>`;
const SearchIcon = createIcon(svgContent$W, "SearchIcon");
SearchIcon.category = "single-color";
SearchIcon.categoryName = "Single Color";
SearchIcon.hasSecondaryColor = false;
const svgContent$V = `<svg viewBox="0 0 10 10" fill="none" > <path d="M1 1H9V9" stroke="{{primaryColor}}" stroke-width="2"/> <path d="M1 8.99989L8.55556 1.44434" stroke="{{primaryColor}}" stroke-width="2"/> </svg>`;
const SeeMoreIcon = createIcon(svgContent$V, "SeeMoreIcon");
SeeMoreIcon.category = "single-color";
SeeMoreIcon.categoryName = "Single Color";
SeeMoreIcon.hasSecondaryColor = false;
const svgContent$U = `<svg viewBox="0 0 14 14" fill="none" > <path d="M9 13V9.5C9 9.22386 9.22386 9 9.5 9H13" stroke="{{primaryColor}}" stroke-linecap="round"/> <path d="M3 0.5H11C12.3807 0.5 13.5 1.61929 13.5 3V8.58594C13.5 8.71849 13.4472 8.84572 13.3535 8.93945L8.93945 13.3535C8.84572 13.4472 8.71849 13.5 8.58594 13.5H3C1.61929 13.5 0.5 12.3807 0.5 11V3C0.5 1.61929 1.61929 0.5 3 0.5Z" stroke="{{primaryColor}}" stroke-linecap="round"/> <path d="M4 4H10" stroke="{{primaryColor}}" stroke-linecap="round"/> <path d="M4 7H7" stroke="{{primaryColor}}" stroke-linecap="round"/> <path d="M4 10H5" stroke="{{primaryColor}}" stroke-linecap="round"/> </svg>`;
const SendResumeIcon = createIcon(svgContent$U, "SendResumeIcon");
SendResumeIcon.category = "single-color";
SendResumeIcon.categoryName = "Single Color";
SendResumeIcon.hasSecondaryColor = false;
const svgContent$T = `<svg viewBox="0 0 24 24" fill="none" > <mask id="mask0_4538_92125" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_4538_92125)"> <path d="M18 8V8C19.6569 8 21 9.34315 21 11V11.5C21 13.1569 19.6569 14.5 18 14.5V14.5" stroke="{{primaryColor}}" stroke-width="2" stroke-linecap="round"/> <path d="M6 15V15C4.34315 15 3 13.6569 3 12L3 11.5C3 9.84315 4.34315 8.5 6 8.5V8.5" stroke="{{primaryColor}}" stroke-width="2" stroke-linecap="round"/> <path d="M6 15V10C6 6.68629 8.68629 4 12 4V4C15.3137 4 18 6.68629 18 10V14C18 17.3137 15.3137 20 12 20H11" stroke="{{primaryColor}}" stroke-width="2" stroke-linecap="round"/> </g> </svg>`;
const ServiceIcon = createIcon(svgContent$T, "ServiceIcon");
ServiceIcon.category = "single-color";
ServiceIcon.categoryName = "Single Color";
ServiceIcon.hasSecondaryColor = false;
const svgContent$S = `<svg viewBox="0 0 24 24" fill="none" > <mask id="mask0_4538_92106" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_4538_92106)"> <circle cx="12" cy="12" r="3" stroke="{{primaryColor}}" stroke-width="2"/> <path d="M14.8679 3.50004L9.14945 3.50017C8.13369 3.50019 7.18693 4.0142 6.63364 4.86605L3.05938 10.369C2.41491 11.3612 2.41381 12.6395 3.05655 13.6328L6.61337 19.1298C7.1662 19.9841 8.11445 20.5 9.13208 20.5H14.8679C15.8856 20.5 16.8338 19.9841 17.3866 19.1298L20.9455 13.6298C21.5872 12.638 21.5872 11.362 20.9455 10.3702L17.3867 4.87028C16.8338 4.01589 15.8855 3.50001 14.8679 3.50004Z" stroke="{{primaryColor}}" stroke-width="2"/> </g> </svg>`;
const SettingIcon = createIcon(svgContent$S, "SettingIcon");
SettingIcon.category = "single-color";
SettingIcon.categoryName = "Single Color";
SettingIcon.hasSecondaryColor = false;
const svgContent$R = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_1_1778" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1_1778)"> <path d="M5 1.75H13C14.7949 1.75 16.25 3.20507 16.25 5V13C16.25 14.7949 14.7949 16.25 13 16.25H5C3.2046 16.25 1.75 14.7964 1.75 13.002V4.99609C1.75 3.20212 3.20412 1.75 5 1.75Z" stroke="{{primaryColor}}" stroke-width="1.5"/> <path d="M6 8C6.55228 8 7 7.55228 7 7C7 6.44772 6.55228 6 6 6C5.44772 6 5 6.42772 5 6.98C5 7.53228 5.44772 8 6 8Z" fill="{{primaryColor}}"/> <path d="M12 8C12.5523 8 13 7.55228 13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.42772 11 6.98C11 7.53228 11.4477 8 12 8Z" fill="{{primaryColor}}"/> <path d="M6.5 10.5C6.5 10.5 7 12 9 12C11 12 11.5 10.5 11.5 10.5" stroke="{{primaryColor}}" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const SmilingFaceIcon = createIcon(svgContent$R, "SmilingFaceIcon");
SmilingFaceIcon.category = "single-color";
SmilingFaceIcon.categoryName = "Single Color";
SmilingFaceIcon.hasSecondaryColor = false;
const svgContent$Q = `<svg viewBox="0 0 19 18" fill="none" > <path d="M13 3.57812C13.8257 5.84418 15.3615 7.76399 17.3711 9C15.3618 10.2358 13.8258 12.1552 13 14.4209C12.1741 12.155 10.6376 10.2358 8.62793 9C10.6379 7.76401 12.1742 5.84444 13 3.57812Z" stroke="{{primaryColor}}" stroke-width="1.5"/> <path d="M1 6H5" stroke="{{primaryColor}}" stroke-linecap="round"/> <path d="M3.00488 4.00586L3.00488 8.00586" stroke="{{primaryColor}}" stroke-linecap="round"/> <path d="M5 13.9941H9" stroke="{{primaryColor}}" stroke-linecap="round"/> <path d="M7.00488 12L7.00488 16" stroke="{{primaryColor}}" stroke-linecap="round"/> </svg>`;
const StarIcon = createIcon(svgContent$Q, "StarIcon");
StarIcon.category = "single-color";
StarIcon.categoryName = "Single Color";
StarIcon.hasSecondaryColor = false;
const svgContent$P = `<svg viewBox="0 0 16 16" fill="none" > <mask id="mask0_9989_192561" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16"> <rect width="16" height="16" fill="#577CF6"/> </mask> <g mask="url(#mask0_9989_192561)"> <path d="M3.00688 9.74162C2.65833 9.43802 2.87305 8.86459 3.33529 8.86459L13.4215 8.86459C13.741 8.86459 14 9.12265 14 9.44098C14 9.75931 13.741 10.0174 13.4215 10.0174L6.74771 10.0174V11.9014C6.74771 12.3305 6.24283 12.5602 5.9193 12.2784L3.00688 9.74162ZM12.9931 6.25838C13.3417 6.56198 13.1269 7.13541 12.6647 7.13541L2.57848 7.13541C2.259 7.13541 2 6.87735 2 6.55902C2 6.24069 2.259 5.98262 2.57848 5.98262L9.25229 5.98262V4.0986C9.25229 3.66955 9.75717 3.43976 10.0807 3.72157L12.9931 6.25838Z" fill="{{primaryColor}}"/> </g> </svg>`;
const SwitchIcon = createIcon(svgContent$P, "SwitchIcon");
SwitchIcon.category = "single-color";
SwitchIcon.categoryName = "Single Color";
SwitchIcon.hasSecondaryColor = false;
const svgContent$O = `<svg viewBox="0 0 18 18" fill="none" > <path d="M8 5V10H13" stroke="{{primaryColor}}" stroke-width="1.5"/> <circle cx="9" cy="9" r="8.25" stroke="{{primaryColor}}" stroke-opacity="0.8" stroke-width="1.5"/> </svg>`;
const TimeIcon = createIcon(svgContent$O, "TimeIcon");
TimeIcon.category = "single-color";
TimeIcon.categoryName = "Single Color";
TimeIcon.hasSecondaryColor = false;
const svgContent$N = `<svg viewBox="0 0 11 8" fill="none" > <path d="M1 4L4 7L10 1" stroke="{{primaryColor}}" stroke-width="1.2" stroke-linecap="square"/> </svg>`;
const UnreadIcon = createIcon(svgContent$N, "UnreadIcon");
UnreadIcon.category = "single-color";
UnreadIcon.categoryName = "Single Color";
UnreadIcon.hasSecondaryColor = false;
const svgContent$M = `<svg viewBox="0 0 14 16" fill="none" > <path d="M3 3.84961H11C12.3255 3.84961 13.4004 4.92452 13.4004 6.25V12.25C13.4004 13.5755 12.3255 14.6504 11 14.6504H3C1.67452 14.6504 0.599609 13.5755 0.599609 12.25V6.25C0.599609 4.92452 1.67452 3.84961 3 3.84961Z" stroke="{{primaryColor}}" stroke-width="1.2" stroke-linecap="round"/> <path d="M10.5 3.25V3.25C10.5 2.14543 9.60457 1.25 8.5 1.25L5.5 1.25C4.39543 1.25 3.5 2.14543 3.5 3.25V3.25" stroke="{{primaryColor}}" stroke-width="1.2" stroke-linecap="round"/> <path d="M1 7.25H13" stroke="{{primaryColor}}" stroke-width="1.2" stroke-linecap="round"/> <path d="M4 11.25H10" stroke="{{primaryColor}}" stroke-width="1.2" stroke-linecap="round"/> </svg>`;
const WorkIcon = createIcon(svgContent$M, "WorkIcon");
WorkIcon.category = "single-color";
WorkIcon.categoryName = "Single Color";
WorkIcon.hasSecondaryColor = false;
const svgContent$L = `<svg viewBox="0 0 16 16" fill="none" > <circle cx="8" cy="8" r="8" fill="{{primaryColor}}"/> <path d="M4 7.14286L6.90909 10L12 5" stroke="white" stroke-width="2"/> </svg>`;
const AgreeFilledIcon = createIcon(svgContent$L, "AgreeFilledIcon");
AgreeFilledIcon.category = "single-filled";
AgreeFilledIcon.categoryName = "Single Filled";
AgreeFilledIcon.hasSecondaryColor = false;
const svgContent$K = `<svg viewBox="0 0 16 16" fill="none" > <mask id="mask0_9553_189676" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16"> <rect width="16" height="16" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_9553_189676)"> <path d="M14.5844 7.33189L14.1378 6.4L13.1689 5.97081L14.1378 5.54162L14.5844 4.60865L15.03 5.54162L16 5.97081L15.03 6.4L14.5844 7.33189ZM12.6067 4.06703L11.9278 2.68649L10.4922 2.03351L11.9278 1.38054L12.6056 0L13.2844 1.38054L14.72 2.03351L13.2844 2.68649L12.6067 4.06703ZM5.81667 16C5.37778 16 5.00556 15.8541 4.70222 15.5611C4.55453 15.4224 4.43783 15.2556 4.35945 15.0711C4.28106 14.8866 4.24266 14.6883 4.24667 14.4886H7.38889C7.38889 14.9114 7.23667 15.2692 6.93333 15.5611C6.63 15.853 6.25778 16 5.81778 16H5.81667ZM2.90778 13.0173C2.90778 12.693 3.17778 12.4314 3.51111 12.4314H8.12333C8.2832 12.4314 8.43652 12.4931 8.54956 12.6031C8.66261 12.7131 8.72611 12.8623 8.72611 13.0178C8.72611 13.1734 8.66261 13.3226 8.54956 13.4325C8.43652 13.5425 8.2832 13.6043 8.12333 13.6043H3.51222C3.43295 13.6045 3.35443 13.5894 3.28116 13.5599C3.2079 13.5305 3.14133 13.4872 3.08527 13.4327C3.02922 13.3782 2.98479 13.3134 2.95452 13.2421C2.92425 13.1708 2.90874 13.0944 2.90889 13.0173H2.90778ZM2.77222 11.493C1.94661 10.9857 1.25294 10.2993 0.745556 9.48757C0.248889 8.6854 0 7.77946 0 6.77297C0 5.25514 0.575556 3.9427 1.72556 2.83568C2.87778 1.72973 4.24111 1.17514 5.81778 1.17514C7.39556 1.17514 8.76 1.72865 9.91 2.83568C11.0611 3.9427 11.6367 5.25514 11.6367 6.77297C11.6367 7.78054 11.3911 8.68541 10.8989 9.48649C10.3937 10.3031 9.69594 10.9908 8.86333 11.493H2.77333H2.77222Z" fill="{{primaryColor}}"/> </g> </svg>`;
const BulbIcon = createIcon(svgContent$K, "BulbIcon");
BulbIcon.category = "single-filled";
BulbIcon.categoryName = "Single Filled";
BulbIcon.hasSecondaryColor = false;
const svgContent$J = `<svg viewBox="0 0 20 20" fill="none" > <path d="M0 9H20V18C20 19.1046 19.1046 20 18 20H2C0.895431 20 0 19.1046 0 18V9Z" fill="{{primaryColor}}"/> <path d="M0 4C0 2.89543 0.895431 2 2 2H18C19.1046 2 20 2.89543 20 4V7H0V4Z" fill="{{primaryColor}}"/> <path d="M5 0.4C5 0.179086 5.17909 0 5.4 0H6.6C6.82091 0 7 0.179086 7 0.4V3H5V0.4Z" fill="{{primaryColor}}"/> <path d="M13 0.4C13 0.179086 13.1791 0 13.4 0H14.6C14.8209 0 15 0.179086 15 0.4V3H13V0.4Z" fill="{{primaryColor}}"/> </svg>`;
const CalendarFillIcon = createIcon(svgContent$J, "CalendarFillIcon");
CalendarFillIcon.category = "single-filled";
CalendarFillIcon.categoryName = "Single Filled";
CalendarFillIcon.hasSecondaryColor = false;
const svgContent$I = `<svg viewBox="0 0 16 16" fill="none" > <mask id="mask0_1_1620" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16"> <rect width="16" height="16" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1_1620)"> <path d="M0 5H16V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V5Z" fill="{{primaryColor}}"/> <path d="M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4H0Z" fill="{{primaryColor}}"/> <rect x="3" y="8" width="10" height="1" fill="white"/> <rect x="5" y="11" width="6" height="1" fill="white"/> </g> </svg>`;
const CardFilledIcon = createIcon(svgContent$I, "CardFilledIcon");
CardFilledIcon.category = "single-filled";
CardFilledIcon.categoryName = "Single Filled";
CardFilledIcon.hasSecondaryColor = false;
const svgContent$H = `<svg viewBox="0 0 18 18" fill="none"> <mask id="mask0_14003_101694" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="{{primaryColor}}"/> </mask> <g mask="url(#mask0_14003_101694)"> <path d="M11.8832 11.0936L13.0106 9.96628C14.4341 8.54279 14.4341 6.23485 13.0106 4.81135C11.5871 3.38785 9.27913 3.38785 7.85563 4.81135L6.7283 5.93868L4.82861 6.2823C3.63733 6.49778 3.1789 7.96297 4.03494 8.81901L9.00291 13.787C9.85894 14.643 11.3241 14.1846 11.5396 12.9933L11.8832 11.0936Z" fill="{{primaryColor}}"/> <path d="M7.16797 10.6523L4.52497 13.2953" stroke="{{primaryColor}}"/> </g> </svg>`;
const ChatPinFilledIcon = createIcon(svgContent$H, "ChatPinFilledIcon");
ChatPinFilledIcon.category = "single-filled";
ChatPinFilledIcon.categoryName = "Single Filled";
ChatPinFilledIcon.hasSecondaryColor = false;
const svgContent$G = `<svg viewBox="0 0 24 24" fill="none"> <mask id="mask0_9200_191004" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="{{primaryColor}}"/> </mask> <g mask="url(#mask0_9200_191004)"> <path d="M2.71914 7.98512L18.8234 4.02684C18.9982 3.9844 19.1813 3.99242 19.3517 4.04997C19.5221 4.10752 19.6727 4.21224 19.7862 4.35203C19.8997 4.49182 19.9714 4.66097 19.9931 4.83991C20.0147 5.01886 19.9854 5.20029 19.9085 5.36322L12.7326 20.4646C12.6498 20.6348 12.5184 20.7765 12.3549 20.8715C12.1915 20.9665 12.0035 21.0105 11.815 20.9979C11.6265 20.9853 11.4461 20.9167 11.2967 20.8008C11.1473 20.6849 11.0357 20.5269 10.9762 20.3472L9.14758 14.6377C9.09524 14.479 9.08572 14.3092 9.12 14.1457C9.15427 13.9821 9.23112 13.8305 9.34274 13.7063L12.4769 10.2274C12.52 10.1834 12.5455 10.125 12.5486 10.0634C12.5517 10.0018 12.5322 9.94123 12.4938 9.89307C12.4553 9.8449 12.4006 9.81251 12.34 9.80202C12.2794 9.79152 12.217 9.80365 12.1647 9.8361L8.00982 12.2682C7.8677 12.3513 7.70652 12.396 7.54202 12.3981C7.37751 12.4002 7.21527 12.3595 7.07112 12.28L2.49081 9.7461C2.32377 9.65331 2.18842 9.51232 2.10231 9.34143C2.01621 9.17055 1.98333 8.97765 2.00795 8.7878C2.03257 8.59794 2.11354 8.41988 2.24036 8.27675C2.36718 8.13361 2.53399 8.03201 2.71914 7.98512Z" fill="{{primaryColor}}"/> </g> </svg>`;
const ChatSendIcon = createIcon(svgContent$G, "ChatSendIcon");
ChatSendIcon.category = "single-filled";
ChatSendIcon.categoryName = "Single Filled";
ChatSendIcon.hasSecondaryColor = false;
const svgContent$F = `<svg viewBox="0 0 16 16" fill="none" > <mask id="mask0_1_1630" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16"> <rect width="16" height="16" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1_1630)"> <circle cx="8" cy="8" r="8" fill="{{primaryColor}}"/> <path d="M8 2V7" stroke="white"/> <path d="M9 9L11.5 11.5" stroke="white"/> <circle cx="8" cy="8" r="1.5" fill="white"/> <circle cx="8" cy="8" r="0.5" fill="{{primaryColor}}"/> </g> </svg>`;
const ClockFilledIcon = createIcon(svgContent$F, "ClockFilledIcon");
ClockFilledIcon.category = "single-filled";
ClockFilledIcon.categoryName = "Single Filled";
ClockFilledIcon.hasSecondaryColor = false;
const svgContent$E = `<svg viewBox="0 0 14 14" fill="none" > <mask id="mask0_1005_28797" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14"> <rect width="14" height="14" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1005_28797)"> <path d="M9.78344 1C8.67616 1 7.64922 1.55511 6.96454 2.4689C6.96051 2.47428 6.9524 2.47426 6.9484 2.46886C6.27094 1.5551 5.23671 1 4.12945 1C2.12699 1 0.5 2.7816 0.5 4.9681C0.5 6.27117 1.0816 7.19141 1.55276 7.92761C2.91472 10.0699 6.3454 12.7276 6.49264 12.838C6.63252 12.9485 6.79448 13 6.95644 13C7.11841 13 7.28037 12.9485 7.42025 12.838C7.56749 12.7276 10.9908 10.0626 12.3601 7.92761C12.8313 7.19141 13.4129 6.27117 13.4129 4.9681C13.4129 2.7816 11.7859 1 9.78344 1Z" fill="{{primaryColor}}"/> </g> </svg>`;
const CollectFilledIcon = createIcon(svgContent$E, "CollectFilledIcon");
CollectFilledIcon.category = "single-filled";
CollectFilledIcon.categoryName = "Single Filled";
CollectFilledIcon.hasSecondaryColor = false;
const svgContent$D = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_11982_163307" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_11982_163307)"> <rect x="1" y="1" width="10" height="16" rx="2" fill="{{primaryColor}}"/> <rect x="12" y="6" width="5" height="11" rx="1" fill="{{primaryColor}}"/> <path d="M4 11H8" stroke="white" stroke-width="1.5" stroke-linecap="round"/> <path d="M4 7H8" stroke="white" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const CompanyFilledIcon = createIcon(svgContent$D, "CompanyFilledIcon");
CompanyFilledIcon.category = "single-filled";
CompanyFilledIcon.categoryName = "Single Filled";
CompanyFilledIcon.hasSecondaryColor = false;
const svgContent$C = `<svg viewBox="0 0 24 24" fill="none" > <g id="Mask group"> <mask id="mask0_3873_203048" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect id="Rectangle 46434" width="24" height="24" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_3873_203048)"> <g id="Group 1000002216"> <rect id="Rectangle 46432" x="3" y="3" width="18" height="14" rx="3" fill="{{primaryColor}}"/> <rect id="Rectangle 46433" x="6" y="19" width="12" height="2" rx="1" fill="{{primaryColor}}"/> <path id="Vector 1594" d="M7 12L10.9019 8.09811C10.9502 8.04984 11.0315 8.06305 11.062 8.1241L12.938 11.8759C12.9685 11.937 13.0498 11.9502 13.0981 11.9019L17 8" stroke="white"/> </g> </g> </g> </svg>`;
const ComputerFilledIcon = createIcon(svgContent$C, "ComputerFilledIcon");
ComputerFilledIcon.category = "single-filled";
ComputerFilledIcon.categoryName = "Single Filled";
ComputerFilledIcon.hasSecondaryColor = false;
const svgContent$B = `<svg viewBox="0 0 16 16" fill="none" > <circle cx="8" cy="8" r="8" fill="{{primaryColor}}"/> <path d="M5.16748 10.832L10.8243 5.1752" stroke="white" stroke-width="2"/> <path d="M5.17529 5.17578L10.8321 10.8326" stroke="white" stroke-width="2"/> </svg>`;
const DisagreeFilledIcon = createIcon(svgContent$B, "DisagreeFilledIcon");
DisagreeFilledIcon.category = "single-filled";
DisagreeFilledIcon.categoryName = "Single Filled";
DisagreeFilledIcon.hasSecondaryColor = false;
const svgContent$A = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_11769_145524" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_11769_145524)"> <path d="M1 4C1 2.89543 1.89543 2 3 2H7.88197C8.56717 2 9.19357 2.38713 9.5 3C9.80643 3.61287 10.4328 4 11.118 4H15C16.1046 4 17 4.89543 17 6V14C17 15.1046 16.1046 16 15 16H3C1.89543 16 1 15.1046 1 14V4Z" fill="{{primaryColor}}"/> <path d="M4 7H14" stroke="white" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const DocumentFilledIcon = createIcon(svgContent$A, "DocumentFilledIcon");
DocumentFilledIcon.category = "single-filled";
DocumentFilledIcon.categoryName = "Single Filled";
DocumentFilledIcon.hasSecondaryColor = false;
const svgContent$z = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_869_157599" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_869_157599)"> <path d="M14 0C15.6569 0 17 1.34315 17 3V15C17 16.6569 15.6569 18 14 18H4C2.34315 18 1 16.6569 1 15V3C1 1.34315 2.34315 0 4 0H14ZM5.62402 13.04V14.5H12.2393V13.04H5.62402ZM9.81934 3.5V4.43945H8.47852V5.79785H9.81934V7.07031C9.42217 6.54031 8.85899 6.27539 8.13086 6.27539C7.65109 6.27545 7.2125 6.39587 6.81543 6.63672C6.41849 6.87754 6.10024 7.22917 5.86035 7.69141C5.6204 8.15396 5.5 8.70885 5.5 9.35449C5.50004 9.99998 5.61602 10.5592 5.84766 11.0312C6.08753 11.4935 6.40581 11.8501 6.80273 12.1006C7.20807 12.3414 7.65109 12.4619 8.13086 12.4619C8.5032 12.4619 8.85113 12.3796 9.17383 12.2158C9.49632 12.0521 9.76099 11.8019 9.96777 11.4648C9.98431 11.6095 10.001 11.8796 10.0176 12.2744H11.5439V5.79785H12.5V4.43945H11.5439V3.5H9.81934ZM8.51562 7.87988C8.87969 7.87988 9.18634 8.00531 9.43457 8.25586C9.69092 8.5064 9.81934 8.87281 9.81934 9.35449C9.81927 9.84574 9.69097 10.2263 9.43457 10.4961C9.18634 10.7659 8.87969 10.9004 8.51562 10.9004C8.15171 10.9003 7.85368 10.7608 7.62207 10.4814C7.39052 10.202 7.27441 9.83059 7.27441 9.36816C7.27449 8.90582 7.39046 8.54428 7.62207 8.28418C7.85367 8.01447 8.15173 7.87996 8.51562 7.87988Z" fill="{{primaryColor}}"/> </g> </svg>`;
const DongFilledIcon = createIcon(svgContent$z, "DongFilledIcon");
DongFilledIcon.category = "single-filled";
DongFilledIcon.categoryName = "Single Filled";
DongFilledIcon.hasSecondaryColor = false;
const svgContent$y = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_587_32096" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#F8F9FA"/> </mask> <g mask="url(#mask0_587_32096)"> <path d="M8.75879 0H2C0.895431 0 0 0.89543 0 2V16C0 17.1046 0.89543 18 2 18H16C17.1046 18 18 17.1046 18 16V4.61538C18 3.51082 17.1046 2.61538 16 2.61538H12.2067C11.9419 2.61538 11.6878 2.51031 11.5003 2.32321L9.46518 0.292177C9.27771 0.105079 9.02366 0 8.75879 0Z" fill="{{primaryColor}}"/> <path d="M9 5V12" stroke="white" stroke-width="1.5" stroke-linecap="round"/> <path d="M6 10L8.85858 12.8586C8.93668 12.9367 9.06332 12.9367 9.14142 12.8586L12 10" stroke="white" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const DownloadFilledIcon = createIcon(svgContent$y, "DownloadFilledIcon");
DownloadFilledIcon.category = "single-filled";
DownloadFilledIcon.categoryName = "Single Filled";
DownloadFilledIcon.hasSecondaryColor = false;
const svgContent$x = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_1_1612" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1_1612)"> <path d="M8.08656 0.96896L0.779473 4.7204C0.0463482 5.09678 0.0576228 6.14862 0.798647 6.5092L8.1249 10.0742C8.67733 10.343 9.32267 10.343 9.8751 10.0742L17.2014 6.5092C17.9424 6.14862 17.9537 5.09678 17.2205 4.7204L9.91345 0.968961C9.34006 0.674585 8.65994 0.674584 8.08656 0.96896Z" fill="{{primaryColor}}"/> <path d="M7.65836 11.3292L2 8.5V13.1812C2 13.9813 2.47679 14.7043 3.21216 15.0195L8.21216 17.1624C8.71526 17.378 9.28474 17.378 9.78784 17.1624L14.7878 15.0195C15.5232 14.7043 16 13.9813 16 13.1812V8.5L10.3416 11.3292C9.49706 11.7515 8.50294 11.7515 7.65836 11.3292Z" fill="{{primaryColor}}"/> </g> </svg>`;
const EducationFilledIcon = createIcon(svgContent$x, "EducationFilledIcon");
EducationFilledIcon.category = "single-filled";
EducationFilledIcon.categoryName = "Single Filled";
EducationFilledIcon.hasSecondaryColor = false;
const svgContent$w = `<svg viewBox="0 0 24 24" fill="none" > <mask id="mask0_9603_203117" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_9603_203117)"> <path d="M20.9834 7.16338L11.8819 12.1595L3.0072 7.28622C3.04944 6.6668 3.33801 6.08585 3.81437 5.66126C4.29073 5.23668 4.91918 5.00027 5.5722 5H18.4278C19.0589 4.99949 19.6682 5.21968 20.1396 5.61863C20.6109 6.01758 20.9111 6.56741 20.9834 7.16338ZM21 8.95239V16.555C21 16.8761 20.9335 17.194 20.8043 17.4907C20.6751 17.7874 20.4856 18.0569 20.2467 18.284C20.0079 18.511 19.7243 18.6911 19.4122 18.814C19.1001 18.9368 18.7656 19 18.4278 19H5.5722C5.2344 19 4.8999 18.9368 4.58781 18.814C4.27571 18.6911 3.99213 18.511 3.75327 18.284C3.51441 18.0569 3.32495 17.7874 3.1957 17.4907C3.06645 17.194 2.99995 16.8761 3 16.555V9.08174L11.4758 13.7332C11.614 13.8086 11.7721 13.8442 11.9311 13.8357C12.0901 13.8273 12.2431 13.7752 12.3715 13.6857C12.383 13.6804 12.3941 13.6743 12.4046 13.6675L21 8.95239Z" fill="{{primaryColor}}"/> </g> </svg>`;
const EmailFilledIcon = createIcon(svgContent$w, "EmailFilledIcon");
EmailFilledIcon.category = "single-filled";
EmailFilledIcon.categoryName = "Single Filled";
EmailFilledIcon.hasSecondaryColor = false;
const svgContent$v = `<svg viewBox="0 0 20 12" fill="none" > <path d="M10.0029 0.167969C15.3496 0.168126 18.9139 4.05645 19.1689 6.00098L19.1357 6.18945C18.6898 8.18538 15.1826 11.8348 10.0029 11.835C4.82303 11.835 1.31503 8.1854 0.869141 6.18945L0.835938 6.00098C1.09092 4.05642 4.656 0.167969 10.0029 0.167969ZM10 2.5C8.067 2.5 6.5 4.067 6.5 6C6.5 7.933 8.067 9.5 10 9.5C11.933 9.5 13.5 7.933 13.5 6C13.5 4.067 11.933 2.5 10 2.5ZM10 4.5C10.8284 4.5 11.5 5.17157 11.5 6C11.5 6.82843 10.8284 7.5 10 7.5C9.17157 7.5 8.5 6.82843 8.5 6C8.5 5.17157 9.17157 4.5 10 4.5Z" fill="{{primaryColor}}"/> </svg>`;
const EyeFilledIcon = createIcon(svgContent$v, "EyeFilledIcon");
EyeFilledIcon.category = "single-filled";
EyeFilledIcon.categoryName = "Single Filled";
EyeFilledIcon.hasSecondaryColor = false;
const svgContent$u = `<svg viewBox="0 0 20 16" fill="none" > <path d="M6.93294 6.69922C6.76311 7.09924 6.66927 7.53933 6.66927 8.0013C6.66927 9.84225 8.16166 11.3346 10.0026 11.3346C10.4645 11.3346 10.9041 11.2402 11.3039 11.0702L13.4873 13.2536C12.4396 13.6139 11.2716 13.8346 10.0026 13.8346C4.82264 13.8346 1.31512 10.1852 0.869303 8.18929L0.835938 8.0013C0.979322 6.90637 2.17257 5.1952 4.14242 3.90869L6.93294 6.69922ZM10.0026 2.16797C15.3498 2.16797 18.9146 6.05686 19.1693 8.0013L19.1359 8.18929C18.8911 9.28517 17.7221 10.8774 15.8612 12.0923L13.0715 9.30257C13.2415 8.90279 13.3359 8.46316 13.3359 8.0013C13.3359 6.16035 11.8436 4.66797 10.0026 4.66797C9.54064 4.66797 9.10054 4.76181 8.70052 4.93164L6.51709 2.74821C7.56493 2.3878 8.73341 2.16797 10.0026 2.16797Z" fill="{{primaryColor}}"/> <path d="M3.33594 1.33203L16.6693 14.6654" stroke="{{primaryColor}}" stroke-width="1.2" stroke-linecap="round"/> <circle cx="10.0026" cy="7.9987" r="1.66667" fill="{{primaryColor}}"/> </svg>`;
const EyeInvisibleFilledIcon = createIcon(svgContent$u, "EyeInvisibleFilledIcon");
EyeInvisibleFilledIcon.category = "single-filled";
EyeInvisibleFilledIcon.categoryName = "Single Filled";
EyeInvisibleFilledIcon.hasSecondaryColor = false;
const svgContent$t = `<svg viewBox="0 0 20 20" fill="none" > <path d="M20 14C20 17.3137 17.3137 20 14 20H6C2.68629 20 0 17.3137 0 14V6C0 2.68629 2.68629 0 6 0H14C17.3137 0 20 2.68629 20 6V14ZM11.0025 3.18681C8.68141 3.18681 8.15462 4.9197 8.15462 6.03226V7.58542H6.81319V9.98036H8.15462V16.7665H10.9755C10.9755 16.7665 10.9755 13.0227 10.9755 9.98036H12.8782L13.1242 7.58295H10.9755V6.17252C10.9755 5.64333 11.3274 5.52027 11.5736 5.52026H13.0898V3.19422L11.0025 3.18681Z" fill="{{primaryColor}}"/> </svg>`;
const FacebookFilledIcon = createIcon(svgContent$t, "FacebookFilledIcon");
FacebookFilledIcon.category = "single-filled";
FacebookFilledIcon.categoryName = "Single Filled";
FacebookFilledIcon.hasSecondaryColor = false;
const svgContent$s = `<svg viewBox="0 0 32 32" fill="none" > <mask id="mask0_555_16942" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32"> <rect width="32" height="32" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_555_16942)"> <path d="M3 16C3 19.4478 4.36964 22.7544 6.80761 25.1924C9.24559 27.6304 12.5522 29 16 29C19.4478 29 22.7544 27.6304 25.1924 25.1924C27.6304 22.7544 29 19.4478 29 16C29 12.5522 27.6304 9.24559 25.1924 6.80761C22.7544 4.36964 19.4478 3 16 3C12.5522 3 9.24559 4.36964 6.80761 6.80761C4.36964 9.24559 3 12.5522 3 16Z" fill="#3A5A98"/> <path d="M13.7271 11.171V13.3512H12.1299V16.0173H13.7271V23.9392H17.0082V16.0173H19.21C19.21 16.0173 19.4163 14.7387 19.516 13.3412H17.0207V11.5181C17.0207 11.2459 17.3783 10.8795 17.732 10.8795H19.5197V8.104H17.0891C13.6459 8.10384 13.7271 10.7724 13.7271 11.171Z" fill="white"/> </g> </svg>`;
const FacebookIcon = createIcon(svgContent$s, "FacebookIcon");
FacebookIcon.category = "single-filled";
FacebookIcon.categoryName = "Single Filled";
FacebookIcon.hasSecondaryColor = false;
const svgContent$r = `<svg viewBox="0 0 14 16" fill="none" > <path d="M12.4444 2.1H9.18944C8.87056 1.172 8.015 0.5 7 0.5C5.985 0.5 5.12944 1.172 4.81056 2.1H1.55556C0.696111 2.1 0 2.816 0 3.7V13.9C0 14.784 0.696111 15.5 1.55556 15.5H12.4444C13.3039 15.5 14 14.784 14 13.9V3.7C14 2.816 13.3039 2.1 12.4444 2.1ZM7 2.1C7.42778 2.1 7.77778 2.456 7.77778 2.9C7.77778 3.344 7.42778 3.7 7 3.7C6.57222 3.7 6.22222 3.344 6.22222 2.9C6.22222 2.456 6.57222 2.1 7 2.1ZM10.8889 11.3C10.8889 11.7418 10.5307 12.1 10.0889 12.1H3.91111C3.46928 12.1 3.11111 11.7418 3.11111 11.3C3.11111 10.8582 3.46928 10.5 3.91111 10.5H10.0889C10.5307 10.5 10.8889 10.8582 10.8889 11.3ZM10.8889 7.1C10.8889 7.54183 10.5307 7.9 10.0889 7.9H3.91111C3.46928 7.9 3.11111 7.54183 3.11111 7.1C3.11111 6.65817 3.46928 6.3 3.91111 6.3H10.0889C10.5307 6.3 10.8889 6.65817 10.8889 7.1Z" fill="{{primaryColor}}"/> </svg>`;
const FilepadFillIcon = createIcon(svgContent$r, "FilepadFillIcon");
FilepadFillIcon.category = "single-filled";
FilepadFillIcon.categoryName = "Single Filled";
FilepadFillIcon.hasSecondaryColor = false;
const svgContent$q = `<svg viewBox="0 0 32 32" fill="none" > <mask id="mask0_555_16921" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32"> <rect width="32" height="32" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_555_16921)"> <path d="M8.99959 16.095C8.99959 15.3092 9.13166 14.5559 9.3658 13.8494L5.2535 10.7368C4.4263 12.4015 3.99717 14.2359 4.00001 16.095C4.00001 18.0205 4.45027 19.8366 5.2511 21.449L9.36221 18.3311C9.12207 17.6102 9.0002 16.855 8.99959 16.095Z" fill="#FBBC05"/> <path d="M16.2234 8.94849C17.8618 8.9452 19.4511 9.50797 20.7229 10.5417L24.2787 7.02365C22.1121 5.15527 19.3343 4 16.2234 4C11.3931 4 7.24114 6.73768 5.25342 10.737L9.36872 13.8495C10.3161 10.9983 13.0176 8.94792 16.2246 8.94792" fill="#EA4335"/> <path d="M16.2757 23.0829C13.0518 23.0829 10.3371 21.0457 9.3838 18.2119L5.25049 21.3058C7.24782 25.2805 11.4202 28.0002 16.2757 28.0002C19.2707 28.0002 22.1307 26.9584 24.2781 25.0048L20.3537 22.0322C19.2473 22.7152 17.8527 23.0835 16.2745 23.0835" fill="#34A853"/> <path d="M27.9999 15.981C27.9999 15.2709 27.8877 14.5055 27.7208 13.7954H16.2742V18.4393H22.8623C22.5339 20.0229 21.6376 21.2401 20.3541 22.0319L24.2778 25.0045C26.5333 22.9541 27.9999 19.8991 27.9999 15.981Z" fill="#4285F4"/> </g> </svg>`;
const GoogleIcon = createIcon(svgContent$q, "GoogleIcon");
GoogleIcon.category = "single-filled";
GoogleIcon.categoryName = "Single Filled";
GoogleIcon.hasSecondaryColor = false;
const svgContent$p = `<svg viewBox="0 0 16 16" fill="none" > <mask id="mask0_1_1606" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16"> <rect width="16" height="16" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1_1606)"> <path d="M16 8.5H10.352C10.352 7.94772 9.90429 7.5 9.352 7.5H6.64655C6.09507 7.5 5.648 7.94706 5.648 8.49855H0V4.11491C0 3.10545 0.843636 2.288 1.88218 2.288H4.70545V1.37164C4.70545 0.613818 5.33673 0 6.11636 0H9.88364C10.6633 0 11.2945 0.613818 11.2945 1.37018V2.28655H14.1164C15.1578 2.28655 16 3.104 16 4.11345V8.5ZM16 9.50145V14.1731C16 15.184 15.1564 16 14.1178 16H1.88509C0.842182 16.0015 0 15.1855 0 14.1731L0 9.50436H5.648C5.648 10.0542 6.09376 10.5 6.64364 10.5H9.352C9.90428 10.5 10.352 10.0523 10.352 9.5H16V9.50145ZM10.352 2.288V1.37164C10.3501 1.24934 10.3 1.13274 10.2125 1.04721C10.1251 0.961673 10.0074 0.914127 9.88509 0.914909H6.11782C6.05688 0.91414 5.99639 0.925382 5.93981 0.947993C5.88322 0.970603 5.83163 1.00414 5.78801 1.04669C5.74438 1.08923 5.70956 1.13996 5.68554 1.19596C5.66151 1.25197 5.64876 1.31216 5.648 1.37309V2.288H10.352Z" fill="{{primaryColor}}"/> </g> </svg>`;
const HandbagFilledIcon = createIcon(svgContent$p, "HandbagFilledIcon");
HandbagFilledIcon.category = "single-filled";
HandbagFilledIcon.categoryName = "Single Filled";
HandbagFilledIcon.hasSecondaryColor = false;
const svgContent$o = `<svg viewBox="0 0 20 20" fill="none" > <mask id="mask0_9804_23594" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20"> <rect width="20" height="20" fill="{{primaryColor}}"/> </mask> <g mask="url(#mask0_9804_23594)"> <path d="M14.0659 1.11133C12.3816 1.11133 10.8199 1.95907 9.78255 3.35339C8.75633 1.95907 7.18354 1.11133 5.4992 1.11133C2.46516 1.11133 0 3.81073 0 7.12364C0 9.09799 0.88121 10.4923 1.5951 11.6078C3.6587 14.8537 8.85672 18.8805 9.07981 19.0479C9.29175 19.2152 9.53715 19.2933 9.78255 19.2933C10.028 19.2933 10.2734 19.2152 10.4853 19.0479C10.7084 18.8805 15.8952 14.8426 17.97 11.6078C18.6839 10.4923 19.5651 9.09799 19.5651 7.12364C19.5651 3.81073 17.0999 1.11133 14.0659 1.11133Z" fill="{{primaryColor}}"/> </g> </svg>`;
const HeartFilledIcon = createIcon(svgContent$o, "HeartFilledIcon");
HeartFilledIcon.category = "single-filled";
HeartFilledIcon.categoryName = "Single Filled";
HeartFilledIcon.hasSecondaryColor = false;
const svgContent$n = `<svg viewBox="0 0 40 40" fill="none" > <circle cx="20" cy="20" r="20" fill="{{primaryColor}}"/> <circle cx="20" cy="14" r="2" fill="white"/> <path d="M20 19V28" stroke="white" stroke-width="3" stroke-linecap="round"/> </svg>`;
const HintFilledIcon = createIcon(svgContent$n, "HintFilledIcon");
HintFilledIcon.category = "single-filled";
HintFilledIcon.categoryName = "Single Filled";
HintFilledIcon.hasSecondaryColor = false;
const svgContent$m = `<svg viewBox="0 0 40 40" fill="none" > <mask id="mask0_307_27461" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40"> <rect width="40" height="40" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_307_27461)"> <path d="M4 8V31.9999C4 34.209 5.79086 35.9999 8 35.9999H31.9999C34.209 35.9999 35.9999 34.209 35.9999 31.9999V8C35.9999 5.79086 34.209 4 31.9999 4H8C5.79086 4 4 5.79086 4 8Z" fill="url(#paint0_linear_307_27461)"/> <path d="M12.2256 21.6807L8.60237 27.5685C7.78235 28.901 8.74105 30.6167 10.3057 30.6167H29.8712C31.3962 30.6167 32.3601 28.9784 31.6195 27.6454L26.1283 17.7611C25.3754 16.4059 23.4336 16.3855 22.6524 17.7246L18.2288 25.3079L15.5564 21.5665C14.7248 20.4023 12.9754 20.4623 12.2256 21.6807Z" fill="white"/> <circle cx="11.5938" cy="11.5977" r="2.21198" fill="white"/> </g> <defs> <linearGradient id="paint0_linear_307_27461" x1="21.7713" y1="9.59998" x2="21.7713" y2="24.3999" gradientUnits="userSpaceOnUse"> <stop offset="1" stop-color="{{primaryColor}}"/> </linearGradient> </defs> </svg>`;
const ImageFilledIcon = createIcon(svgContent$m, "ImageFilledIcon");
ImageFilledIcon.category = "single-filled";
ImageFilledIcon.categoryName = "Single Filled";
ImageFilledIcon.hasSecondaryColor = false;
const svgContent$l = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_1_5390" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1_5390)"> <path d="M11 1C14.3137 1 17 3.68629 17 7V11C17 14.3137 14.3137 17 11 17H3C1.89543 17 1 16.1046 1 15V7C1 3.68629 3.68629 1 7 1H11ZM5 10.25C4.58579 10.25 4.25 10.5858 4.25 11C4.25 11.4142 4.58579 11.75 5 11.75H10C10.4142 11.75 10.75 11.4142 10.75 11C10.75 10.5858 10.4142 10.25 10 10.25H5ZM5 6.75C4.58579 6.75 4.25 7.08579 4.25 7.5C4.25 7.91421 4.58579 8.25 5 8.25H13C13.4142 8.25 13.75 7.91421 13.75 7.5C13.75 7.08579 13.4142 6.75 13 6.75H5Z" fill="{{primaryColor}}"/> </g> </svg>`;
const InformationFilledIcon = createIcon(svgContent$l, "InformationFilledIcon");
InformationFilledIcon.category = "single-filled";
InformationFilledIcon.categoryName = "Single Filled";
InformationFilledIcon.hasSecondaryColor = false;
const svgContent$k = `<svg viewBox="0 0 16 16" fill="none" > <mask id="mask0_9445_189412" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16"> <rect width="16" height="16" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_9445_189412)"> <path d="M8 0C3.56773 0 0 3.6 0 8C0 12.4 3.56773 16 8 16C12.4309 16 16 12.4 16 8C16 3.6 12.4002 0 8 0ZM6.03173 3.264C6.09587 3.128 6.2629 3.064 6.49541 3.064H9.59946C9.76783 3.064 9.93486 3.128 10.0003 3.264C10.0344 3.34482 10.0491 3.43245 10.0433 3.51994C10.0375 3.60743 10.0114 3.69236 9.96693 3.768L9.232 4.8C9.14429 4.89951 9.03751 4.98051 8.91795 5.03821C8.79839 5.09592 8.66846 5.12917 8.53583 5.136H7.53499C7.40118 5.12925 7.27003 5.09608 7.14916 5.03841C7.02828 4.98073 6.92007 4.8997 6.8308 4.8L6.09587 3.768C5.93553 3.6 5.93553 3.432 6.03173 3.264ZM10.0952 11.104L8.39151 12.736C8.28157 12.8369 8.1398 12.8963 7.99065 12.904C7.82362 12.904 7.68732 12.872 7.59111 12.736L5.88876 11.104C5.72039 10.936 5.65625 10.64 5.72039 10.4L7.05662 6.096C7.12076 5.864 7.42542 5.632 7.72073 5.632H8.28862C8.59328 5.632 8.85652 5.832 8.95273 6.096L10.289 10.4C10.3148 10.5242 10.3108 10.6527 10.2774 10.775C10.244 10.8974 10.182 11.0101 10.0965 11.104H10.0952Z" fill="{{primaryColor}}"/> </g> </svg>`;
const LeadingFilledIcon = createIcon(svgContent$k, "LeadingFilledIcon");
LeadingFilledIcon.category = "single-filled";
LeadingFilledIcon.categoryName = "Single Filled";
LeadingFilledIcon.hasSecondaryColor = false;
const svgContent$j = `<svg viewBox="0 0 16 16" fill="none" > <circle cx="8" cy="8" r="7.75" fill="#275D00"/> <circle cx="8" cy="8" r="7.75" fill="url(#paint0_radial_869_155713)" fill-opacity="0.9"/> <circle cx="8" cy="8" r="7.75" stroke="white" stroke-width="0.5"/> <path d="M12.35 3C9.22325 4.64325 7.24025 9.57375 7.24025 9.57375L6.02 7.1475L3.5 8.71275C5.04375 9.47708 6.37858 10.6052 7.3895 12C8.30525 10.275 11.1268 6.75675 12.5 6.44325C11.966 5.19075 12.275 4.17375 12.35 3Z" fill="white"/> <defs> <radialGradient id="paint0_radial_869_155713" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(12.3636 0.727272) rotate(120.763) scale(17.7736 8.54703)"> <stop stop-color="white" stop-opacity="0.9"/> <stop offset="1" stop-color="white" stop-opacity="0"/> </radialGradient> </defs> </svg>`;
const Legalize2Icon = createIcon(svgContent$j, "Legalize2Icon");
Legalize2Icon.category = "single-filled";
Legalize2Icon.categoryName = "Single Filled";
Legalize2Icon.hasSecondaryColor = false;
const svgContent$i = `<svg viewBox="0 0 34 34" fill="none" > <g id="icon_icon_legalize"> <g id="Rectangle 46168" filter="url(#filter0_i_1850_61114)"> <rect width="34" height="34" rx="17" fill="#275D00"/> <rect width="34" height="34" rx="17" fill="url(#paint0_radial_1850_61114)"/> </g> <g id="icon_legalize"> <mask id="mask0_1850_61114" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="6" y="6" width="22" height="22"> <rect id="Rectangle 46154" x="6" y="6" width="22" height="22" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1850_61114)"> <g id="Group 742274"> <path id="Subtract" d="M17 12.1875C21.1767 12.1875 24.5625 15.5733 24.5625 19.75C24.5625 23.9267 21.1767 27.3125 17 27.3125C12.8233 27.3125 9.4375 23.9267 9.4375 19.75C9.4375 15.5733 12.8233 12.1875 17 12.1875Z" fill="white"/> <path id="Subtract_2" d="M17.5525 16.1136C17.2424 15.4559 16.7538 15.4684 16.4474 16.1136L15.5397 18.0378L13.5094 18.3453C12.8138 18.4507 12.6755 18.9415 13.1677 19.4423L14.6367 20.9395L14.2889 23.0557C14.1696 23.7799 14.5716 24.0701 15.1805 23.7352L16.0016 23.2833L16.9953 22.7355H16.9966L18.8114 23.7352C19.4328 24.0775 19.821 23.7674 19.703 23.0571L19.3559 20.9395L20.8255 19.4423C21.3365 18.9315 21.1731 18.4507 20.4925 18.3453L18.4623 18.0378L17.5525 16.1136Z" fill="#275D00"/> <path id="Subtract_3" d="M16.8483 10.7726C15.1151 10.8011 13.5019 11.3169 12.1432 12.1875L8.75 6.6875H14.25L16.8483 10.7726ZM21.8561 12.1875C20.4973 11.3169 18.8843 10.801 17.1511 10.7726L19.75 6.6875H25.25L21.8561 12.1875Z" fill="white"/> </g> </g> </g> </g> <defs> <filter id="filter0_i_1850_61114" x="0" y="0" width="34" height="34" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"> <feFlood flood-opacity="0" result="BackgroundImageFix"/> <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/> <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/> <feOffset/> <feGaussianBlur stdDeviation="2"/> <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/> <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"/> <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1850_61114"/> </filter> <radialGradient id="paint0_radial_1850_61114" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(22.6667 1.88889) rotate(107.216) scale(35.1004 13.7322)"> <stop stop-color="white" stop-opacity="0.6"/> <stop offset="1" stop-color="white" stop-opacity="0"/> </radialGradient> </defs> </svg>`;
const LegalizeIcon = createIcon(svgContent$i, "LegalizeIcon");
LegalizeIcon.category = "single-filled";
LegalizeIcon.categoryName = "Single Filled";
LegalizeIcon.hasSecondaryColor = false;
const svgContent$h = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_1_1600" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1_1600)"> <path d="M9 0C13.4182 0 16.9999 3.62645 17 8.09982C17 12.5733 10.1111 18 9 18C7.88889 18 1 12.5733 1 8.09982C1.0001 3.62645 4.58184 0 9 0ZM9 5.68421C7.61929 5.68421 6.5 6.74459 6.5 8.05263C6.5 9.36067 7.61929 10.4211 9 10.4211C10.3807 10.4211 11.5 9.36067 11.5 8.05263C11.5 6.74459 10.3807 5.68421 9 5.68421Z" fill="{{primaryColor}}"/> </g> </svg>`;
const LocationFilledIcon = createIcon(svgContent$h, "LocationFilledIcon");
LocationFilledIcon.category = "single-filled";
LocationFilledIcon.categoryName = "Single Filled";
LocationFilledIcon.hasSecondaryColor = false;
const svgContent$g = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_11769_145537" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_11769_145537)"> <rect x="1" y="2" width="16" height="14" rx="2" fill="{{primaryColor}}"/> <path d="M5 7H13" stroke="white" stroke-width="1.5" stroke-linecap="round"/> <path d="M5 11H11" stroke="white" stroke-width="1.5" stroke-linecap="round"/> </g> </svg>`;
const MenuFilledIcon = createIcon(svgContent$g, "MenuFilledIcon");
MenuFilledIcon.category = "single-filled";
MenuFilledIcon.categoryName = "Single Filled";
MenuFilledIcon.hasSecondaryColor = false;
const svgContent$f = `<svg viewBox="0 0 20 21" fill="none" > <path d="M16 0C18.2091 0 20 1.79086 20 4V14C20 16.2091 18.2091 18 16 18H13.8281C13.2978 18.0001 12.7891 18.2109 12.4141 18.5859L10.7071 20.2929C10.3166 20.6834 9.68342 20.6834 9.29289 20.2929L7.58594 18.5859C7.21094 18.2109 6.7022 18.0001 6.17188 18H4C1.79086 18 0 16.2091 0 14V4C0 1.79086 1.79086 0 4 0H16ZM7 10C6.44772 10 6 10.4477 6 11C6 11.5523 6.44772 12 7 12H13C13.5523 12 14 11.5523 14 11C14 10.4477 13.5523 10 13 10H7ZM5 6C4.44772 6 4 6.44772 4 7C4 7.55228 4.44772 8 5 8H15C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6H5Z" fill="{{primaryColor}}"/> </svg>`;
const MessageFilledIcon = createIcon(svgContent$f, "MessageFilledIcon");
MessageFilledIcon.category = "single-filled";
MessageFilledIcon.categoryName = "Single Filled";
MessageFilledIcon.hasSecondaryColor = false;
const svgContent$e = `<svg viewBox="0 0 40 40" fill="none" > <mask id="mask0_292_27407" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40"> <rect width="40" height="40" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_292_27407)"> <path d="M32.25 40H7.75C5.54086 40 3.75 38.2091 3.75 36V4C3.75 1.79086 5.54086 0 7.75 0H24.9191C26.0062 0 27.0464 0.442416 27.8004 1.22543L35.1313 8.83825C35.849 9.5836 36.25 10.5781 36.25 11.6128V36C36.25 38.2091 34.4591 40 32.25 40Z" fill="{{primaryColor}}"/> <path d="M28.4462 17.5148C27.9206 16.9497 26.8694 16.6294 25.3678 16.6294C24.5606 16.6294 23.6408 16.7048 22.6272 16.8932C22.0641 16.328 21.4822 15.6687 20.9378 14.8964C20.5436 14.3501 20.2058 13.785 19.9054 13.2199C20.5061 11.355 20.7877 9.84795 20.7877 8.75538C20.7877 7.53095 20.3559 6.25 19.0795 6.25C18.6853 6.25 18.3099 6.49489 18.1034 6.83396C17.5403 7.87002 17.7843 10.1305 18.7792 12.3533C18.4038 13.4647 18.0283 14.5385 17.5403 15.7252C17.1273 16.7236 16.6393 17.7785 16.1325 18.7204C13.2793 19.8883 11.4398 21.2446 11.2708 22.2995C11.1957 22.6951 11.3271 23.0719 11.6087 23.3544C11.7026 23.4298 12.078 23.75 12.6974 23.75C14.5933 23.75 16.583 20.623 17.5966 18.7204C18.3662 18.4567 19.1546 18.2118 19.9242 17.9857C20.7689 17.7409 21.6324 17.5525 22.402 17.4206C24.3917 19.2478 26.1561 19.5492 27.0384 19.5492C28.1271 19.5492 28.5213 19.0971 28.6527 18.7204C28.8591 18.2495 28.709 17.722 28.4649 17.4395L28.4462 17.5148ZM27.4326 18.2871C27.3575 18.6827 26.9633 18.9464 26.4189 18.9464C26.2688 18.9464 26.1374 18.9276 25.9872 18.8899C24.9923 18.645 24.0726 18.1364 23.134 17.3453C24.0538 17.1946 24.8234 17.1569 25.3114 17.1569C25.8558 17.1569 26.3251 17.1757 26.6254 17.2699C26.982 17.3453 27.5452 17.5902 27.4326 18.2871ZM21.9327 17.0439C21.2569 17.1757 20.5436 17.3453 19.7928 17.5525C19.1921 17.722 18.5727 17.8916 17.9533 18.1176C18.2911 17.4583 18.5727 16.8178 18.8355 16.215C19.1546 15.4615 19.3986 14.708 19.6614 13.9922C19.9242 14.4443 20.2058 14.8964 20.4873 15.292C20.9566 15.9136 21.4446 16.5164 21.9327 17.0439ZM18.5352 7.1542C18.6478 6.94699 18.8543 6.83396 19.0232 6.83396C19.5676 6.83396 19.6614 7.47443 19.6614 7.98305C19.6614 8.83073 19.3986 10.1305 18.9669 11.6187C18.2161 9.54656 18.1597 7.83235 18.5352 7.1542ZM15.7008 19.5304C14.3868 21.7532 13.1104 23.1472 12.3408 23.1472C12.1906 23.1472 12.0592 23.0907 11.9466 23.0153C11.7964 22.8646 11.7213 22.6763 11.7589 22.4502C11.909 21.659 13.3919 20.5476 15.7008 19.5304Z" fill="white"/> <path d="M23.2012 28.75H26.5581V29.399H23.9854V30.9497H26.2869V31.5986H23.9854V33.7505H23.2012V28.75Z" fill="white"/> <path d="M19.465 28.75C19.9878 28.75 20.4594 28.8479 20.8796 29.0437C21.2998 29.2396 21.6297 29.5265 21.8691 29.9045C22.1085 30.2825 22.2282 30.7288 22.2282 31.2434C22.2282 31.7671 22.1085 32.218 21.8691 32.596C21.6297 32.9695 21.2998 33.2564 20.8796 33.4568C20.4643 33.6526 19.9927 33.7505 19.465 33.7505H17.8965V28.75H19.465ZM19.3624 33.1084C20.0025 33.1084 20.5009 32.9467 20.8576 32.6233C21.2192 32.2954 21.4 31.8355 21.4 31.2434C21.4 30.6559 21.2192 30.2005 20.8576 29.8772C20.5009 29.5493 20.0025 29.3853 19.3624 29.3853H18.6807V33.1084H19.3624Z" fill="white"/> <path d="M15.1526 28.75C15.5338 28.75 15.8734 28.816 16.1714 28.9481C16.4695 29.0802 16.6991 29.2669 16.8604 29.5083C17.0265 29.7496 17.1096 30.0252 17.1096 30.3349C17.1096 30.6445 17.0265 30.9201 16.8604 31.1614C16.6991 31.3983 16.4695 31.5827 16.1714 31.7148C15.8782 31.8468 15.5386 31.9129 15.1526 31.9129H14.2218V33.7505H13.4375V28.75H15.1526ZM15.0573 31.2776C15.4434 31.2776 15.7414 31.1933 15.9515 31.0248C16.1665 30.8518 16.274 30.6218 16.274 30.3349C16.274 30.0479 16.1665 29.818 15.9515 29.6449C15.7414 29.4718 15.4434 29.3853 15.0573 29.3853H14.2218V31.2776H15.0573Z" fill="white"/> </g> </svg>`;
const PdfFilledIcon = createIcon(svgContent$e, "PdfFilledIcon");
PdfFilledIcon.category = "single-filled";
PdfFilledIcon.categoryName = "Single Filled";
PdfFilledIcon.hasSecondaryColor = false;
const svgContent$d = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_11769_145485" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_11769_145485)"> <path d="M9 7.5C5.14576 7.5 1.92812 10.2256 1.1694 13.8545C0.952297 14.8929 1.44061 15.9227 2.40904 16.3558C3.62353 16.8989 5.71067 17.5 9 17.5C12.2893 17.5 14.3765 16.8989 15.591 16.3558C16.5594 15.9227 17.0477 14.8929 16.8306 13.8545C16.0719 10.2256 12.8542 7.5 9 7.5Z" fill="{{primaryColor}}"/> <circle cx="9" cy="6" r="5" fill="{{primaryColor}}"/> <path d="M11 7C11 8 10 8.5 9 8.5C8 8.5 7 8 7 7" stroke="white" stroke-linecap="round"/> </g> </svg>`;
const PeopleFilledIcon = createIcon(svgContent$d, "PeopleFilledIcon");
PeopleFilledIcon.category = "single-filled";
PeopleFilledIcon.categoryName = "Single Filled";
PeopleFilledIcon.hasSecondaryColor = false;
const svgContent$c = `<svg viewBox="0 0 24 24" fill="none" > <mask id="mask0_3903_216920" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_3903_216920)"> <path d="M12 3C14.2091 3 16 4.79086 16 7C16 7.72875 15.8044 8.41155 15.4639 9H16C18.7614 9 21 11.2386 21 14V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V14C3 11.2386 5.23858 9 8 9H8.53613C8.19564 8.41155 8 7.72875 8 7C8 4.79086 9.79086 3 12 3ZM9 16V17.2002H15V16H9ZM7 14H17V12.7998H7V14Z" fill="{{primaryColor}}"/> </g> </svg>`;
const PersonnelFilledIcon = createIcon(svgContent$c, "PersonnelFilledIcon");
PersonnelFilledIcon.category = "single-filled";
PersonnelFilledIcon.categoryName = "Single Filled";
PersonnelFilledIcon.hasSecondaryColor = false;
const svgContent$b = `<svg viewBox="0 0 24 24" fill="none" > <mask id="mask0_9603_203112" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_9603_203112)"> <path d="M4.69854 4.91207C4.59348 5.01449 4.46817 5.15968 4.32034 5.34501C4.26256 5.41742 4.20253 5.49508 4.14025 5.58024C3.92819 5.868 3.72438 6.16175 3.52907 6.46112L3.51894 6.4735C3.02293 7.19945 2.84997 8.49076 3.14299 9.29398L3.15575 9.32662L3.16326 9.36151C3.17076 9.3964 3.21841 9.55922 3.30845 9.81434C3.46642 10.2716 3.64443 10.7218 3.84198 11.1634C4.49266 12.6302 5.32837 14.0078 6.32874 15.2625C6.64463 15.6584 6.97814 16.0399 7.32825 16.406C7.76228 16.8585 8.22136 17.2864 8.70332 17.6875C10.2104 18.9364 11.9084 19.9351 13.7324 20.6453C14.01 20.7504 14.1605 20.798 14.2006 20.8104L14.2231 20.8179L14.2434 20.8254C15.0373 21.133 16.3445 21.0257 17.0986 20.5902L17.1136 20.5827C17.1661 20.5553 17.2787 20.4926 17.4288 20.4075C17.6895 20.26 17.9323 20.1148 18.1502 19.982C18.2354 19.9295 18.318 19.877 18.3934 19.8297C18.7265 19.6144 18.9569 19.4467 19.0743 19.3266C19.6506 18.7459 19.6529 18.0578 19.0818 17.4823C18.3131 16.7091 17.5518 15.9479 16.8157 15.2201C16.2492 14.6592 15.5731 14.6592 15.0073 15.2201C14.8467 15.3803 14.5938 15.6279 14.2757 15.9479L13.1163 17.1019L12.7404 16.9492C12.5104 16.8542 12.2833 16.7524 12.0594 16.6438C11.4961 16.3754 10.9528 16.0669 10.4337 15.7205C9.97297 15.4129 9.57226 15.0921 9.23909 14.7669C8.87366 14.4116 8.51047 13.9486 8.15967 13.393C7.85236 12.9025 7.57715 12.3926 7.33575 11.8665C7.23834 11.6592 7.14725 11.449 7.06261 11.2362L6.91479 10.8629L7.99158 9.78695C8.24722 9.53259 8.50197 9.27735 8.75585 9.02124C9.3419 8.43298 9.33927 7.75731 8.7506 7.16418C8.25234 6.66146 6.83487 5.24484 6.50433 4.91958C6.22631 4.63445 5.91303 4.49414 5.60237 4.49414C5.29209 4.49414 4.98143 4.63445 4.69816 4.91207H4.69854Z" fill="{{primaryColor}}"/> <path d="M16.1309 11.2461V11.2446L16.1084 11.2461C16.0165 11.2461 15.9278 11.2123 15.8591 11.1513C15.7904 11.0902 15.7466 11.0061 15.7358 10.9148L15.7332 10.8709C15.6494 10.2098 15.3482 9.59526 14.8769 9.12406C14.4056 8.65286 13.791 8.35172 13.1297 8.26805C13.0785 8.26798 13.0278 8.25745 12.9808 8.23711C12.9338 8.21676 12.8914 8.18702 12.8563 8.14972C12.8211 8.11241 12.794 8.06833 12.7765 8.02016C12.759 7.972 12.7515 7.92077 12.7546 7.86962H12.7542V7.09679C12.7598 7.0452 12.7759 6.99532 12.8016 6.95023C12.8272 6.90515 12.8619 6.86583 12.9034 6.83472C12.945 6.80361 12.9924 6.78138 13.0429 6.76941C13.0934 6.75744 13.1458 6.75599 13.1969 6.76514C15.3524 6.97598 17.0625 8.70624 17.2411 10.8709C17.2377 11.078 17.0696 11.2461 16.8625 11.2461L16.8813 11.245V11.2461H16.1309ZM13.1294 3C13.1455 3 13.1613 3.00113 13.177 3.003C17.3979 3.2161 20.7833 6.60007 20.9975 10.8207C21.0047 10.8737 21.0004 10.9276 20.985 10.9789C20.9696 11.0301 20.9434 11.0775 20.9082 11.1178C20.873 11.1581 20.8296 11.1904 20.7808 11.2125C20.7321 11.2346 20.6792 11.2461 20.6257 11.2461L20.6332 11.2457V11.2461H19.8828V11.2453L19.8716 11.2461C19.7797 11.2461 19.691 11.2123 19.6223 11.1513C19.5536 11.0902 19.5097 11.0061 19.499 10.9148L19.4964 10.8709V10.8619C19.305 7.43818 16.5624 4.69612 13.1384 4.50403L13.1294 4.50441C13.0791 4.50443 13.0294 4.49437 12.9831 4.47481C12.9369 4.45526 12.895 4.42661 12.86 4.39057C12.825 4.35454 12.7976 4.31184 12.7794 4.26502C12.7613 4.21819 12.7527 4.16819 12.7542 4.11799V3.36766C12.7561 3.26947 12.7965 3.17596 12.8667 3.10722C12.9368 3.03847 13.0312 2.99998 13.1294 3Z" fill="{{primaryColor}}"/> </g> </svg>`;
const PhoneFilledIcon = createIcon(svgContent$b, "PhoneFilledIcon");
PhoneFilledIcon.category = "single-filled";
PhoneFilledIcon.categoryName = "Single Filled";
PhoneFilledIcon.hasSecondaryColor = false;
const svgContent$a = `<svg viewBox="0 0 12 12" fill="none"> <path d="M8.88323 8.09362L10.0106 6.96628C11.4341 5.54279 11.4341 3.23485 10.0106 1.81135C8.58707 0.387854 6.27913 0.387854 4.85563 1.81135L3.7283 2.93868L1.82861 3.2823C0.637328 3.49778 0.178905 4.96297 1.03494 5.81901L6.00291 10.787C6.85894 11.643 8.32414 11.1846 8.53962 9.99331L8.88323 8.09362Z" fill="{{primaryColor}}"/> </svg>`;
const PinFilledIcon = createIcon(svgContent$a, "PinFilledIcon");
PinFilledIcon.category = "single-filled";
PinFilledIcon.categoryName = "Single Filled";
PinFilledIcon.hasSecondaryColor = false;
const svgContent$9 = `<svg viewBox="0 0 18 18" fill="none" > <mask id="mask0_1084_1752" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"> <rect width="18" height="18" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1084_1752)"> <path d="M12.6 6.44075C12.3161 6.9543 11.9401 7.39796 11.4952 7.74432C12.6543 2.63922 7.92165 1 7.92165 1C9.32 6.65599 3 7.09078 3 11.6497C3 16.2084 7.83357 17 7.83357 17C7.53149 16.6354 7.25701 16.2438 7.01289 15.8294C7.34634 15.9654 7.69007 16.0681 8.04 16.1366C5.03604 12.4714 8.0072 10.1894 8.81202 9.67207C8.79178 9.89404 8.80092 10.1181 8.83913 10.3371C8.8528 10.8854 9.09202 11.6983 10.0391 12.6999C11.312 14.0476 9.9128 16.1393 9.9128 16.1393C10.1463 16.1346 10.3779 16.0916 10.6 16.0117C10.4671 16.3588 10.3016 16.6894 10.1064 16.9983C11.6784 17.0195 15 14.726 15 11.608C15 8.48999 12.6 6.44075 12.6 6.44075Z" fill="{{primaryColor}}"/> </g> </svg>`;
const PopularFilledIcon = createIcon(svgContent$9, "PopularFilledIcon");
PopularFilledIcon.category = "single-filled";
PopularFilledIcon.categoryName = "Single Filled";
PopularFilledIcon.hasSecondaryColor = false;
const svgContent$8 = `<svg viewBox="0 0 20 20" fill="none" > <mask id="mask0_3017_256585" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20"> <rect width="20" height="20" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_3017_256585)"> <path d="M0.981963 7.66991L1.29462 6.92801C1.75088 5.84534 2.56638 4.95303 3.60371 4.4014C7.60276 2.27479 12.3972 2.27479 16.3963 4.4014C17.4336 4.95303 18.2491 5.84534 18.7054 6.92801L19.018 7.6699C19.6459 9.15985 19.6459 10.8401 19.018 12.3301L18.7054 13.072C18.2491 14.1547 17.4336 15.047 16.3963 15.5986C12.3972 17.7252 7.60276 17.7252 3.60371 15.5986C2.56638 15.047 1.75088 14.1547 1.29462 13.072L0.981964 12.3301C0.354061 10.8402 0.354061 9.15985 0.981963 7.66991Z" fill="{{primaryColor}}"/> <path d="M12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5C11.3807 12.5 12.5 11.3807 12.5 10Z" fill="white"/> </g> </svg>`;
const PreviewFillIcon = createIcon(svgContent$8, "PreviewFillIcon");
PreviewFillIcon.category = "single-filled";
PreviewFillIcon.categoryName = "Single Filled";
PreviewFillIcon.hasSecondaryColor = false;
const svgContent$7 = `<svg viewBox="0 0 24 24" fill="none" > <mask id="mask0_4538_92114" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_4538_92114)"> <path d="M19.5 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V8C2.5 6.89543 3.39543 6 4.5 6H19.5C20.6046 6 21.5 6.89543 21.5 8V19.5C21.5 20.6046 20.6046 21.5 19.5 21.5Z" fill="{{primaryColor}}"/> <path d="M7 16.5H17" stroke="white" stroke-width="2"/> <path d="M7 12.5H13" stroke="white" stroke-width="2"/> <path d="M8 3.5L8 9" stroke="white" stroke-width="2"/> <path d="M9 3.5C9 2.94772 8.55228 2.5 8 2.5C7.44771 2.5 7 2.94772 7 3.5L9 3.5ZM8 3.5L7 3.5L7 6L8 6L9 6L9 3.5L8 3.5Z" fill="{{primaryColor}}"/> <path d="M16 3.5L16 9" stroke="white" stroke-width="2"/> <path d="M17 3.5C17 2.94772 16.5523 2.5 16 2.5C15.4477 2.5 15 2.94772 15 3.5L17 3.5ZM16 3.5L15 3.5L15 6L16 6L17 6L17 3.5L16 3.5Z" fill="{{primaryColor}}"/> </g> </svg>`;
const ProfileFilledIcon = createIcon(svgContent$7, "ProfileFilledIcon");
ProfileFilledIcon.category = "single-filled";
ProfileFilledIcon.categoryName = "Single Filled";
ProfileFilledIcon.hasSecondaryColor = false;
const svgContent$6 = `<svg viewBox="0 0 7 10" fill="none" > <path d="M0 1.94319C0 1.12982 0.91937 0.656693 1.58124 1.12946L5.86077 4.18627C6.41912 4.58509 6.41912 5.41491 5.86077 5.81373L1.58124 8.87054C0.91937 9.34331 0 8.87018 0 8.05681V1.94319Z" fill="{{primaryColor}}"/> </svg>`;
const RectangleFilledIcon = createIcon(svgContent$6, "RectangleFilledIcon");
RectangleFilledIcon.category = "single-filled";
RectangleFilledIcon.categoryName = "Single Filled";
RectangleFilledIcon.hasSecondaryColor = false;
const svgContent$5 = `<svg viewBox="0 0 24 24" fill="none" > <mask id="mask0_4680_71342" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_4680_71342)"> <path d="M15.6039 3C16.6352 3.00014 17.594 3.53027 18.1429 4.40332L21.9818 10.5068C22.603 11.4946 22.5949 12.7536 21.9613 13.7334L18.1478 19.6289C17.595 20.4835 16.6461 21 15.6283 21H8.41736C7.39604 21 6.4448 20.4805 5.89294 19.6211L2.03748 13.6152C1.40535 12.6307 1.40273 11.3684 2.03162 10.3818L5.85486 4.38672C6.40584 3.52291 7.35957 3 8.38416 3H15.6039ZM12.0004 8.5C10.0674 8.5 8.50037 10.067 8.50037 12C8.50037 13.933 10.0674 15.5 12.0004 15.5C13.9332 15.4998 15.5004 13.9329 15.5004 12C15.5004 10.0671 13.9332 8.50017 12.0004 8.5Z" fill="{{primaryColor}}"/> </g> </svg>`;
const SettingFilledIcon = createIcon(svgContent$5, "SettingFilledIcon");
SettingFilledIcon.category = "single-filled";
SettingFilledIcon.categoryName = "Single Filled";
SettingFilledIcon.hasSecondaryColor = false;
const svgContent$4 = `<svg viewBox="0 0 20 20" fill="none" > <path d="M19.9147 1.14722C19.9904 1.20475 20.0261 1.30494 19.9783 1.43887L13.6207 19.264C13.4689 19.6895 13.0947 19.9708 12.644 19.998C12.6202 19.9994 12.5967 20 12.5735 20C12.1516 20 11.7772 19.7701 11.586 19.3873L8.46884 13.154C8.39659 13.0093 8.36201 12.8533 8.36314 12.6989L19.9147 1.14722ZM18.5621 0.0217112C18.6949 -0.0257352 18.7951 0.00896172 18.8528 0.0833696L7.30028 11.636C7.14622 11.6369 6.99041 11.6034 6.84616 11.5313L0.612842 8.4141C0.209127 8.2122 -0.0250585 7.80671 0.00213498 7.35612C0.0296402 6.9055 0.31086 6.5312 0.736158 6.37937L18.5621 0.0217112Z" fill="{{primaryColor}}"/> </svg>`;
const SubtractFilledIcon = createIcon(svgContent$4, "SubtractFilledIcon");
SubtractFilledIcon.category = "single-filled";
SubtractFilledIcon.categoryName = "Single Filled";
SubtractFilledIcon.hasSecondaryColor = false;
const svgContent$3 = `<svg viewBox="0 0 20 20" fill="none" > <path d="M14 0C17.3137 1.28851e-07 20 2.68629 20 6V14C20 17.3137 17.3137 20 14 20H6C2.68629 20 1.28855e-07 17.3137 0 14V6C1.28855e-07 2.68629 2.68629 1.28851e-07 6 0H14ZM7.81543 5.7041C6.65856 4.26586 5.89194 5.37565 5.2666 6.00098C4.54746 6.7201 5.23586 9.42439 7.90918 12.0977C10.5824 14.7708 13.2866 15.4592 14.0059 14.7246C14.6312 14.0993 15.7254 13.3326 14.3027 12.1758C12.8806 11.0194 12.4737 11.5975 11.8174 12.2383C11.3796 12.7229 10.2222 11.77 9.2373 10.7852C8.25246 9.80033 7.2988 8.64288 7.75195 8.18945C8.39289 7.5329 8.97204 7.14215 7.81543 5.7041Z" fill="{{primaryColor}}"/> </svg>`;
const TelFilledIcon = createIcon(svgContent$3, "TelFilledIcon");
TelFilledIcon.category = "single-filled";
TelFilledIcon.categoryName = "Single Filled";
TelFilledIcon.hasSecondaryColor = false;
const svgContent$2 = `<svg viewBox="0 0 20 18" fill="none" > <path d="M8.47628 0.232699C9.4655 -0.0775664 10.5345 -0.0775664 11.5237 0.232699C12.5102 0.542211 13.2846 1.2745 14.0618 2.30445C14.8377 3.33045 15.6944 4.76079 16.7967 6.60601L16.8414 6.67845C17.9451 8.52235 18.8018 9.95269 19.3362 11.113C19.8721 12.28 20.14 13.2862 19.9265 14.2529C19.714 15.2244 19.1846 16.1087 18.4125 16.7817C17.6423 17.4495 16.5958 17.73 15.2772 17.8657C13.967 18 12.2521 18 10.0447 18H9.95535C7.74792 18 6.03443 18 4.72281 17.8657C3.40421 17.7313 2.3577 17.4495 1.58887 16.7817C0.816237 16.1089 0.286308 15.2246 0.0735261 14.2529C-0.139961 13.2862 0.127945 12.28 0.663756 11.113C1.19817 9.95401 2.05491 8.52235 3.15863 6.67845L3.20189 6.60601C4.307 4.76211 5.16234 3.33045 5.93816 2.30445C6.71536 1.2745 7.48978 0.542211 8.47628 0.232699ZM9.06931 13.3902C9.06931 13.8749 9.48512 14.2687 9.99581 14.2687H10.0042C10.1262 14.2686 10.2469 14.2457 10.3595 14.2014C10.4721 14.1572 10.5743 14.0924 10.6604 14.0108C10.7465 13.9292 10.8146 13.8324 10.861 13.7259C10.9074 13.6194 10.9311 13.5054 10.9307 13.3902C10.9309 13.2752 10.9071 13.1613 10.8606 13.055C10.8141 12.9486 10.7459 12.852 10.6599 12.7705C10.5739 12.6891 10.4717 12.6244 10.3592 12.5803C10.2467 12.5361 10.126 12.5133 10.0042 12.5131H9.99581C9.87396 12.5133 9.75333 12.5361 9.64083 12.5803C9.52832 12.6244 9.42613 12.6891 9.3401 12.7705C9.25406 12.852 9.18587 12.9486 9.1394 13.055C9.09294 13.1613 9.06912 13.2752 9.06931 13.3902ZM9.06931 9.87893C9.06931 10.1119 9.16736 10.3354 9.3419 10.5001C9.51644 10.6649 9.75317 10.7574 10 10.7574C10.2468 10.7574 10.4836 10.6649 10.6581 10.5001C10.8326 10.3354 10.9307 10.1119 10.9307 9.87893V6.3663C10.9307 6.13331 10.8326 5.90987 10.6581 5.74512C10.4836 5.58037 10.2468 5.48782 10 5.48782C9.75317 5.48782 9.51644 5.58037 9.3419 5.74512C9.16736 5.90987 9.06931 6.13331 9.06931 6.3663V9.87893Z" fill="{{primaryColor}}"/> </svg>`;
const WarningFilledIcon = createIcon(svgContent$2, "WarningFilledIcon");
WarningFilledIcon.category = "single-filled";
WarningFilledIcon.categoryName = "Single Filled";
WarningFilledIcon.hasSecondaryColor = false;
const svgContent$1 = `<svg viewBox="0 0 40 40" fill="none" > <mask id="mask0_304_27441" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40"> <rect width="40" height="40" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_304_27441)"> <path d="M32.25 40H7.75C5.54086 40 3.75 38.2091 3.75 36V4C3.75 1.79086 5.54086 0 7.75 0H24.9191C26.0062 0 27.0464 0.442416 27.8004 1.22543L35.1313 8.83825C35.849 9.5836 36.25 10.5781 36.25 11.6128V36C36.25 38.2091 34.4591 40 32.25 40Z" fill="{{primaryColor}}"/> <path d="M28.5837 26.25H29.3808V32.4102H28.6775C28.6514 32.0432 28.6332 31.8139 28.6228 31.7221C28.4769 31.9812 28.2842 32.1755 28.0445 32.305C27.8101 32.4345 27.56 32.4992 27.2944 32.4992C26.9766 32.4992 26.6796 32.4129 26.4035 32.2402C26.1274 32.0675 25.906 31.8166 25.7393 31.4874C25.5726 31.1528 25.4893 30.7588 25.4893 30.3055C25.4893 29.8576 25.5726 29.4691 25.7393 29.1399C25.906 28.8053 26.1274 28.5516 26.4035 28.379C26.6796 28.2009 26.9766 28.1118 27.2944 28.1118C27.5496 28.1118 27.7893 28.1712 28.0133 28.2899C28.2425 28.4086 28.4326 28.584 28.5837 28.8161V26.25ZM27.4272 31.7545C27.745 31.7545 28.0159 31.6358 28.2399 31.3983C28.4691 31.1609 28.5837 30.7966 28.5837 30.3055C28.5837 29.8198 28.4691 29.461 28.2399 29.2289C28.0159 28.9969 27.745 28.8808 27.4272 28.8808C27.0938 28.8808 26.8255 29.005 26.6223 29.2532C26.4244 29.5014 26.3254 29.8522 26.3254 30.3055C26.3254 30.7642 26.4244 31.1204 26.6223 31.3741C26.8255 31.6277 27.0938 31.7545 27.4272 31.7545Z" fill="white"/> <path d="M24.7758 28.1128C24.9113 28.1128 25.0363 28.1317 25.1509 28.1695C25.2707 28.2072 25.3645 28.2585 25.4322 28.3233L25.1275 28.9789C25.0076 28.9034 24.8748 28.8656 24.7289 28.8656C24.432 28.8656 24.1897 28.9924 24.0022 29.2461C23.8199 29.4997 23.7287 29.8613 23.7287 30.3308V32.4112H22.9238V28.2099H23.6349C23.6453 28.469 23.661 28.6956 23.6818 28.8899C23.8016 28.6309 23.9527 28.4366 24.135 28.3071C24.3226 28.1776 24.5362 28.1128 24.7758 28.1128Z" fill="white"/> <path d="M18.0488 30.3065C18.0488 29.8802 18.14 29.4997 18.3223 29.1651C18.5047 28.8305 18.7469 28.5715 19.0491 28.388C19.3564 28.2045 19.6872 28.1128 20.0415 28.1128C20.3905 28.1128 20.7161 28.2045 21.0183 28.388C21.3204 28.5715 21.5627 28.8305 21.745 29.1651C21.9273 29.4997 22.0185 29.8802 22.0185 30.3065C22.0185 30.7328 21.9273 31.1133 21.745 31.4479C21.5627 31.7825 21.3204 32.0415 21.0183 32.225C20.7161 32.4085 20.3905 32.5002 20.0415 32.5002C19.6872 32.5002 19.3564 32.4085 19.0491 32.225C18.7469 32.0415 18.5047 31.7825 18.3223 31.4479C18.14 31.1133 18.0488 30.7328 18.0488 30.3065ZM18.8928 30.3065C18.8928 30.749 18.9996 31.0998 19.2132 31.3588C19.432 31.6179 19.7055 31.7474 20.0337 31.7474C20.3671 31.7474 20.6406 31.6179 20.8542 31.3588C21.0678 31.0998 21.1746 30.749 21.1746 30.3065C21.1746 29.864 21.0652 29.5132 20.8464 29.2542C20.6328 28.9951 20.3619 28.8656 20.0337 28.8656C19.7055 28.8656 19.432 28.9951 19.2132 29.2542C18.9996 29.5132 18.8928 29.864 18.8928 30.3065Z" fill="white"/> <path d="M14.7744 26.4771L16.1106 30.9778L17.3375 26.4851H18.1502L16.3998 32.4106H15.7434L14.4071 28.0556L13.1178 32.4106H12.4692L10.625 26.4851H11.508L12.8364 30.9778L14.0789 26.4771H14.7744Z" fill="white"/> <path d="M20.9017 11.25L22.6309 16.6291L24.2243 11.25H26.25L23.3967 20H21.7787L20.0247 14.7763L18.3202 20H16.7144L13.75 11.25H15.9239L17.6161 16.6291L19.2465 11.25H20.9017Z" fill="white"/> </g> </svg>`;
const WordFilledIcon = createIcon(svgContent$1, "WordFilledIcon");
WordFilledIcon.category = "single-filled";
WordFilledIcon.categoryName = "Single Filled";
WordFilledIcon.hasSecondaryColor = false;
const svgContent = `<svg viewBox="0 0 20 20" fill="none" > <path d="M14 0C17.3137 1.28851e-07 20 2.68629 20 6V14C20 17.3137 17.3137 20 14 20H6C2.68629 20 1.28855e-07 17.3137 0 14V6C1.28855e-07 2.68629 2.68629 1.28851e-07 6 0H14ZM9.99316 3.5C6.42183 3.50015 3.5 6.21644 3.5 9.57031C3.50763 10.3636 3.6715 11.1459 3.98047 11.8652C4.28949 12.5846 4.73655 13.2248 5.29199 13.7422C5.53861 13.9779 5.43506 14.8945 4.96777 16.5C6.69383 15.6411 7.75894 15.2667 8.13574 15.377C8.74726 15.5438 9.37622 15.6284 10.0068 15.6279C13.5777 15.6278 16.5 12.9115 16.5 9.55762C16.5 6.20363 13.5772 3.5 9.99316 3.5Z" fill="{{primaryColor}}"/> <path d="M11.2105 7.50185C11.3013 7.49247 11.3922 7.51898 11.4637 7.57569C11.5351 7.63239 11.5815 7.71482 11.593 7.80531V11.1228C11.6003 11.2137 11.5717 11.3039 11.5133 11.3741C11.455 11.4442 11.3715 11.4888 11.2808 11.4981C11.19 11.5075 11.0992 11.481 11.0277 11.4243C10.9562 11.3676 10.9098 11.2852 10.8983 11.1947V7.8772C10.891 7.78625 10.9196 7.69605 10.978 7.62592C11.0363 7.5558 11.1198 7.51124 11.2105 7.50185ZM10.2019 8.96675C10.295 8.9698 10.3832 9.00903 10.4478 9.0761C10.5125 9.14318 10.5485 9.2328 10.5481 9.32597V11.1219L10.5511 11.1228C10.5515 11.216 10.5155 11.3056 10.4509 11.3727C10.3862 11.4397 10.298 11.4791 10.2049 11.4821C10.149 11.4841 10.0936 11.4705 10.045 11.443C9.99633 11.4155 9.95625 11.3751 9.92914 11.3262C9.74985 11.4373 9.54114 11.4917 9.33045 11.4821C9.13933 11.4823 8.95064 11.4389 8.77885 11.3551C8.60707 11.2714 8.45673 11.1494 8.3392 10.9987C8.22167 10.848 8.14008 10.6725 8.1007 10.4855C8.06132 10.2984 8.06518 10.1049 8.11196 9.91957C8.15873 9.73427 8.24718 9.56207 8.37059 9.41615C8.49401 9.27023 8.64914 9.15438 8.82411 9.07751C8.99909 9.00063 9.18939 8.96468 9.38036 8.97249C9.57132 8.9803 9.75799 9.03165 9.92611 9.12254C9.95548 9.07569 9.99608 9.03694 10.0442 9.00973C10.0924 8.98252 10.1466 8.96774 10.2019 8.96675ZM12.7753 8.99025C13.0168 8.93014 13.2708 8.94305 13.5051 9.02727C13.7393 9.11151 13.9434 9.26327 14.0914 9.46346C14.2394 9.66365 14.3247 9.90324 14.3365 10.1519V10.2121C14.3478 10.534 14.2307 10.8472 14.0111 11.0829C13.7914 11.3185 13.4871 11.4572 13.1652 11.4685C13.1564 11.4688 13.1476 11.469 13.1388 11.4691C12.8901 11.4809 12.6435 11.4186 12.4302 11.2903C12.2169 11.1619 12.0464 10.9732 11.9403 10.748C11.8343 10.5228 11.7974 10.2712 11.8343 10.025C11.8713 9.77883 11.9804 9.54913 12.1479 9.36494C12.3154 9.18076 12.5337 9.05035 12.7753 8.99025ZM7.79551 7.8772C7.85855 7.8769 7.92036 7.8948 7.97349 7.92873C8.02661 7.96266 8.06883 8.01119 8.09507 8.0685C8.12448 8.12381 8.13989 8.18557 8.13989 8.24822C8.13988 8.31084 8.12447 8.37253 8.09507 8.42782L6.67964 10.7626H7.78338C7.87704 10.7626 7.96692 10.7999 8.03314 10.8661C8.09936 10.9323 8.13653 11.0222 8.13653 11.1159C8.13653 11.2095 8.09936 11.2994 8.03314 11.3656C7.96692 11.4319 7.87704 11.4691 7.78338 11.4691H6.05843C5.99692 11.4692 5.93656 11.4525 5.88381 11.4208C5.83104 11.3892 5.78779 11.3437 5.75887 11.2894C5.72942 11.232 5.71405 11.1685 5.71405 11.104C5.71405 11.0395 5.72941 10.9759 5.75887 10.9185L7.16055 8.59574H6.05843C5.96316 8.59573 5.87182 8.55787 5.80445 8.49051C5.73708 8.42314 5.69923 8.33179 5.69922 8.23652C5.69922 8.14124 5.73707 8.04981 5.80445 7.98243C5.87182 7.91507 5.96317 7.87721 6.05843 7.8772H7.79551ZM9.36336 9.67273H9.23345C9.16773 9.68597 9.10614 9.71481 9.05384 9.75674C8.9947 9.79188 8.94531 9.84126 8.91018 9.90041C8.87403 9.9589 8.84959 10.0239 8.83829 10.0917V10.3081C8.83917 10.3414 8.84731 10.3741 8.86211 10.4038C8.87423 10.4398 8.89806 10.464 8.91018 10.5C8.93704 10.5251 8.9611 10.5531 8.98195 10.5834C9.00277 10.607 9.02703 10.6273 9.05384 10.6436C9.11435 10.6787 9.17869 10.7068 9.24557 10.7272C9.31718 10.7394 9.39038 10.7394 9.46199 10.7272C9.60005 10.6925 9.71947 10.6059 9.79533 10.4855C9.87119 10.365 9.89773 10.2199 9.86938 10.0804C9.84179 9.96521 9.77754 9.86203 9.68631 9.78641C9.59507 9.71078 9.48173 9.66678 9.36336 9.66104V9.67273ZM13.0305 9.67273C12.9946 9.68484 12.9708 9.68488 12.9349 9.69655C12.899 9.70824 12.8752 9.7325 12.8392 9.74462C12.8123 9.76533 12.7881 9.78942 12.7674 9.8164C12.7208 9.86718 12.6806 9.92351 12.6475 9.98399C12.6352 10.0146 12.627 10.0468 12.6233 10.0796V10.296C12.6241 10.3294 12.6324 10.3623 12.6475 10.3921C12.6592 10.4281 12.6835 10.4519 12.6956 10.4878C12.7219 10.5106 12.7424 10.5394 12.7552 10.5717C12.7762 10.595 12.8004 10.6152 12.8271 10.6315C12.855 10.6544 12.8878 10.6709 12.9228 10.6796C12.9587 10.6913 12.9829 10.7034 13.0188 10.7155C13.0905 10.7273 13.1636 10.7273 13.2353 10.7155C13.3733 10.6808 13.4927 10.5942 13.5686 10.4738C13.6445 10.3533 13.671 10.2082 13.6427 10.0688C13.6175 9.95463 13.5535 9.85279 13.4616 9.78056C13.3755 9.71285 13.2698 9.6751 13.1607 9.67273H13.0305Z" fill="{{primaryColor}}"/> </svg>`;
const ZaloFilledIcon = createIcon(svgContent, "ZaloFilledIcon");
ZaloFilledIcon.category = "single-filled";
ZaloFilledIcon.categoryName = "Single Filled";
ZaloFilledIcon.hasSecondaryColor = false;
const ICON_CATEGORIES = {
  "single-color": {
    name: "Single Color",
    description: "单色图标，仅使用主色描边",
    defaultProps: { "primaryColor": "currentColor", "secondaryColor": null }
  },
  "dual-color": {
    name: "Dual Color",
    description: "双色图标，使用主色描边和副色填充",
    defaultProps: { "primaryColor": "currentColor", "secondaryColor": "#6B7280" }
  },
  "single-filled": {
    name: "Single Filled",
    description: "单色填充图标，使用主色填充",
    defaultProps: { "primaryColor": "currentColor", "secondaryColor": null }
  },
  "dual-filled": {
    name: "Dual Filled",
    description: "双色填充图标，使用主色和副色填充",
    defaultProps: { "primaryColor": "currentColor", "secondaryColor": "#6B7280" }
  }
};
const ALL_ICONS = [
  {
    name: "AgeFilledIcon",
    category: "dual-filled",
    categoryName: "Dual Filled",
    fileName: "age-filled"
  },
  {
    name: "BriefcaseFilledIcon",
    category: "dual-filled",
    categoryName: "Dual Filled",
    fileName: "briefcase-filled"
  },
  {
    name: "BuildingFilledIcon",
    category: "dual-filled",
    categoryName: "Dual Filled",
    fileName: "building-filled"
  },
  {
    name: "BuildingStaffFilledIcon",
    category: "dual-filled",
    categoryName: "Dual Filled",
    fileName: "building-staff-filled"
  },
  {
    name: "CameraFilledIcon",
    category: "dual-filled",
    categoryName: "Dual Filled",
    fileName: "camera-filled"
  },
  {
    name: "ChatFilledIcon",
    category: "dual-filled",
    categoryName: "Dual Filled",
    fileName: "chat-filled"
  },
  {
    name: "ChatLessFilledIcon",
    category: "dual-filled",
    categoryName: "Dual Filled",
    fileName: "chat-less-filled"
  },
  {
    name: "CirclePointFilledIcon",
    category: "dual-filled",
    categoryName: "Dual Filled",
    fileName: "circle-point-filled"
  },
  {
    name: "ResumeIcon",
    category: "dual-filled",
    categoryName: "Dual Filled",
    fileName: "resume"
  },
  {
    name: "SmilingFaceFilledIcon",
    category: "dual-filled",
    categoryName: "Dual Filled",
    fileName: "smiling-face-filled"
  },
  {
    name: "StaffFilledIcon",
    category: "dual-filled",
    categoryName: "Dual Filled",
    fileName: "staff-filled"
  },
  {
    name: "AgreeIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "agree"
  },
  {
    name: "BackIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "back"
  },
  {
    name: "BriefcaseIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "briefcase"
  },
  {
    name: "ChatBagIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "chat-bag"
  },
  {
    name: "ChatCorrectIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "chat-correct"
  },
  {
    name: "ChatDotIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "chat-dot"
  },
  {
    name: "ChatForbiddenIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "chat-forbidden"
  },
  {
    name: "ChatImageIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "chat-image"
  },
  {
    name: "ChatMarkIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "chat-mark"
  },
  {
    name: "ChatMoreIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "chat-more"
  },
  {
    name: "ChatPinIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "chat-pin"
  },
  {
    name: "ClockIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "clock"
  },
  {
    name: "CloseIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "close"
  },
  {
    name: "CollectIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "collect"
  },
  {
    name: "CompanyIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "company"
  },
  {
    name: "ComputerIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "computer"
  },
  {
    name: "CopyIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "copy"
  },
  {
    name: "CorrectIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "correct"
  },
  {
    name: "DateIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "date"
  },
  {
    name: "DeleteIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "delete"
  },
  {
    name: "DownIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "down"
  },
  {
    name: "EditIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "edit"
  },
  {
    name: "EditPenIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "edit-pen"
  },
  {
    name: "HintIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "hint"
  },
  {
    name: "InformationIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "information"
  },
  {
    name: "JoinCompanyIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "join-company"
  },
  {
    name: "LeaveCompanyIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "leave-company"
  },
  {
    name: "LocationIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "location"
  },
  {
    name: "LogoutIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "logout"
  },
  {
    name: "MagnifierIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "magnifier"
  },
  {
    name: "MenuIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "menu"
  },
  {
    name: "MoreIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "more"
  },
  {
    name: "PeopleIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "people"
  },
  {
    name: "PhraseIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "phrase"
  },
  {
    name: "PlusBoldIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "plus-bold"
  },
  {
    name: "PlusIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "plus"
  },
  {
    name: "PreviewIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "preview"
  },
  {
    name: "ProfileIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "profile"
  },
  {
    name: "ReadedIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "readed"
  },
  {
    name: "RejectIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "reject"
  },
  {
    name: "RepublishIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "republish"
  },
  {
    name: "ResetIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "reset"
  },
  {
    name: "RevokeIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "revoke"
  },
  {
    name: "RightIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "right"
  },
  {
    name: "SearchIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "search"
  },
  {
    name: "SeeMoreIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "see-more"
  },
  {
    name: "SendResumeIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "send-resume"
  },
  {
    name: "ServiceIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "service"
  },
  {
    name: "SettingIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "setting"
  },
  {
    name: "SmilingFaceIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "smiling-face"
  },
  {
    name: "StarIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "star"
  },
  {
    name: "SwitchIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "switch"
  },
  {
    name: "TimeIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "time"
  },
  {
    name: "UnreadIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "unread"
  },
  {
    name: "WorkIcon",
    category: "single-color",
    categoryName: "Single Color",
    fileName: "work"
  },
  {
    name: "AgreeFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "agree-filled"
  },
  {
    name: "BulbIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "bulb"
  },
  {
    name: "CalendarFillIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "calendar-fill"
  },
  {
    name: "CardFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "card-filled"
  },
  {
    name: "ChatPinFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "chat-pin-filled"
  },
  {
    name: "ChatSendIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "chat-send"
  },
  {
    name: "ClockFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "clock-filled"
  },
  {
    name: "CollectFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "collect-filled"
  },
  {
    name: "CompanyFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "company-filled"
  },
  {
    name: "ComputerFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "computer-filled"
  },
  {
    name: "DisagreeFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "disagree-filled"
  },
  {
    name: "DocumentFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "document-filled"
  },
  {
    name: "DongFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "dong-filled"
  },
  {
    name: "DownloadFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "download-filled"
  },
  {
    name: "EducationFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "education-filled"
  },
  {
    name: "EmailFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "email-filled"
  },
  {
    name: "EyeFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "eye-filled"
  },
  {
    name: "EyeInvisibleFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "eye-invisible-filled"
  },
  {
    name: "FacebookFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "facebook-filled"
  },
  {
    name: "FacebookIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "facebook"
  },
  {
    name: "FilepadFillIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "filepad-fill"
  },
  {
    name: "GoogleIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "google"
  },
  {
    name: "HandbagFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "handbag-filled"
  },
  {
    name: "HeartFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "heart-filled"
  },
  {
    name: "HintFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "hint-filled"
  },
  {
    name: "ImageFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "image-filled"
  },
  {
    name: "InformationFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "information-filled"
  },
  {
    name: "LeadingFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "leading-filled"
  },
  {
    name: "Legalize2Icon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "legalize2"
  },
  {
    name: "LegalizeIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "legalize"
  },
  {
    name: "LocationFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "location-filled"
  },
  {
    name: "MenuFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "menu-filled"
  },
  {
    name: "MessageFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "message-filled"
  },
  {
    name: "PdfFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "pdf-filled"
  },
  {
    name: "PeopleFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "people-filled"
  },
  {
    name: "PersonnelFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "personnel-filled"
  },
  {
    name: "PhoneFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "phone-filled"
  },
  {
    name: "PinFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "pin-filled"
  },
  {
    name: "PopularFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "popular-filled"
  },
  {
    name: "PreviewFillIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "preview-fill"
  },
  {
    name: "ProfileFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "profile-filled"
  },
  {
    name: "RectangleFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "rectangle-filled"
  },
  {
    name: "SettingFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "setting-filled"
  },
  {
    name: "SubtractFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "subtract-filled"
  },
  {
    name: "TelFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "tel-filled"
  },
  {
    name: "WarningFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "warning-filled"
  },
  {
    name: "WordFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "word-filled"
  },
  {
    name: "ZaloFilledIcon",
    category: "single-filled",
    categoryName: "Single Filled",
    fileName: "zalo-filled"
  }
];
export {
  ALL_ICONS,
  AgeFilledIcon,
  AgreeFilledIcon,
  AgreeIcon,
  BackIcon,
  BriefcaseFilledIcon,
  BriefcaseIcon,
  BuildingFilledIcon,
  BuildingStaffFilledIcon,
  BulbIcon,
  CalendarFillIcon,
  CameraFilledIcon,
  CardFilledIcon,
  ChatBagIcon,
  ChatCorrectIcon,
  ChatDotIcon,
  ChatFilledIcon,
  ChatForbiddenIcon,
  ChatImageIcon,
  ChatLessFilledIcon,
  ChatMarkIcon,
  ChatMoreIcon,
  ChatPinFilledIcon,
  ChatPinIcon,
  ChatSendIcon,
  CirclePointFilledIcon,
  ClockFilledIcon,
  ClockIcon,
  CloseIcon,
  CollectFilledIcon,
  CollectIcon,
  CompanyFilledIcon,
  CompanyIcon,
  ComputerFilledIcon,
  ComputerIcon,
  CopyIcon,
  CorrectIcon,
  DateIcon,
  DeleteIcon,
  DisagreeFilledIcon,
  DocumentFilledIcon,
  DongFilledIcon,
  DownIcon,
  DownloadFilledIcon,
  EditIcon,
  EditPenIcon,
  EducationFilledIcon,
  EmailFilledIcon,
  EyeFilledIcon,
  EyeInvisibleFilledIcon,
  FacebookFilledIcon,
  FacebookIcon,
  FilepadFillIcon,
  GoogleIcon,
  HandbagFilledIcon,
  HeartFilledIcon,
  HintFilledIcon,
  HintIcon,
  ICON_CATEGORIES,
  ImageFilledIcon,
  InformationFilledIcon,
  InformationIcon,
  JoinCompanyIcon,
  LeadingFilledIcon,
  LeaveCompanyIcon,
  Legalize2Icon,
  LegalizeIcon,
  LocationFilledIcon,
  LocationIcon,
  LogoutIcon,
  MagnifierIcon,
  MenuFilledIcon,
  MenuIcon,
  MessageFilledIcon,
  MoreIcon,
  PdfFilledIcon,
  PeopleFilledIcon,
  PeopleIcon,
  PersonnelFilledIcon,
  PhoneFilledIcon,
  PhraseIcon,
  PinFilledIcon,
  PlusBoldIcon,
  PlusIcon,
  PopularFilledIcon,
  PreviewFillIcon,
  PreviewIcon,
  ProfileFilledIcon,
  ProfileIcon,
  ReadedIcon,
  RectangleFilledIcon,
  RejectIcon,
  RepublishIcon,
  ResetIcon,
  ResumeIcon,
  RevokeIcon,
  RightIcon,
  SearchIcon,
  SeeMoreIcon,
  SendResumeIcon,
  ServiceIcon,
  SettingFilledIcon,
  SettingIcon,
  SmilingFaceFilledIcon,
  SmilingFaceIcon,
  StaffFilledIcon,
  StarIcon,
  SubtractFilledIcon,
  SwitchIcon,
  TelFilledIcon,
  TimeIcon,
  UnreadIcon,
  WarningFilledIcon,
  WordFilledIcon,
  WorkIcon,
  ZaloFilledIcon,
  createIcon
};
//# sourceMappingURL=index.js.map
